import suitabilityMetadata from "./suitability-metadata";

export const IDS = {
    // Landscape
    SLOPE_ASPECT: 205,
    SLOPE_STEEPNESS: 204,
    EROSION: 198,
    SURFACE_ROCK: 202,

    // Land Suitability
    ARABLE_SUITABILITY: 203,
    GENERAL_SUITABILITY: 211,
    PROD_FOR_SUITABILITY: 210,
    LUC_MAIN: 209,
    LUC_EXTENDED: 209,
    LRI_PHYS_SUSTAIN: 206,
    PROT_AREA_NET: 201,
    LENZ_TEC: 212,
    POT_NAT_VEG: 207,
    VEG: 196,
    WETLANDS_HISTORIC: 197,
    WETLANDS_CURRENT: 199,
    BASIC_ECOSYS: 208,
    ECOSYS_WATER_YIELD: 235,
    ECOSYS_GHG: 231,
    ECOSYS_NITRATE: 232,
    ECOSYS_SEDTLOST: 233,
    ECOSYS_SEDTRETAINED: 234,
    LRI_HPL_LAND: 290,
}

export const NAMES = {
    // Landscape
    SLOPE_ASPECT: "aspect_slope",
    SLOPE_STEEPNESS: "slope",
    EROSION: "lri_observed_erosion",
    SURFACE_ROCK: "lri_rock_group",

    // Land Suitability
    ARABLE_SUITABILITY: "lri_arable_suitability",
    GENERAL_SUITABILITY: "lri_general_suitability",
    PROD_FOR_SUITABILITY: "lri_prod_for_suitability",
    LUC_EXTENDED: "lri_luc_extended",
    LUC_MAIN: "lri_luc_main",
    LRI_PHYS_SUSTAIN: "lri_phys_sustain",
    LRI_HPL: "lri_luc_hpl",

    PROT_AREA_NET: "lenz_prot_areas",
    LENZ_TEC: "lenz_tec",
    POT_NAT_VEG: "lenz_potnatveg",
    VEG: "lcdb5_veg",
    WETLANDS_HISTORIC: "wetlands_historic",
    WETLANDS_CURRENT: "wetlands_current",
    BASIC_ECOSYS: "ecosys_basic_eco",
    ECOSYS_WATER_YIELD: "ecosys_wateryield",
    ECOSYS_GHG: "ecosys_ghg",
    ECOSYS_NITRATE: "ecosys_nleach",
    ECOSYS_SEDTLOST: "ecosys_sedtlost",
    ECOSYS_SEDTRETAINED: "ecosys_sedtretained",
}

export const topicMetadata = [
    {
        "id": "06c72872-cba1-4052-8f50-35d334a752cf",
        "name": "ecosys_nleach",
        "provenance": "1733a393-e289-4c9f-b437-851f0617e5d0"
    },
    {
        "id": "08850390-b322-456b-8342-6993a917a986",
        "name": "lenz_tec",
        "provenance": "365247cf-ac92-4e17-9309-c0687b1daeaa",
        "description": "27bb1887-a6f9-4e94-8748-f64db10addd1"
    },
    {
        "id": "0a099ce5-9750-4e96-ada6-26c72b00b1d2",
        "name": "lri_prod_for_suitability",
        "provenance": "8772bc77-560b-48e4-a886-22f8490bf6dc",
        "description": "c6e504cf-2463-419a-bf7d-fed220e119dc"
    },
    {
        "id": "0d2c1cb1-3a82-40b1-bead-8fa9f4cbe8df",
        "name": null
    },
    {
        "id": "28379e52-85c3-410b-9703-c42341be5c2e",
        "name": "lri_general_suitability",
        "provenance": "8772bc77-560b-48e4-a886-22f8490bf6dc",
        "description": "cb8d3240-dcca-4e6f-acaa-e09941cce5e7"
    },
    {
        "id": "325c5656-0baf-4fb5-ad52-90da52405942",
        "name": "lcdb5_veg",
        "provenance": "125b5bad-f339-48d0-8861-3d599b9126a9",
        "description": "92af14b8-3ed8-4cc5-8657-acf5bc736080"
    },
    {
        "id": "341c91e7-1c81-427a-80e9-8b4c5f919500",
        "name": "ecosys_ghg",
        "provenance": "8b67b46b-283b-4310-92fd-d1dc26e067be"
    },
    {
        "id": "3622521d-2cd6-4450-a5c2-b2897911d2f1",
        "name": "ecosys_wateryield",
        "provenance": "d8e86d38-9791-4491-ad21-c0e30f05318a"
    },
    {
        "id": "4a1db66b-a1ab-4f20-9322-6aad44cd1e16",
        "name": "lenz_prot_areas",
        "provenance": "13d667bb-2d51-4dd1-91f1-cebbc6d9f27a",
        "description": "2b0527d9-527a-4c11-a2d3-1f599261f44a"
    },
    {
        "id": "5119e41d-84f4-4fbe-a239-494367a06f2e",
        "name": "lri_luc_main",
        "provenance": "8772bc77-560b-48e4-a886-22f8490bf6dc",
        "description": "112fdbff-f3a0-44a8-903d-033a6f369e21"
    },
    {
        "id": "7d3a116a-97ed-4ce4-9a45-331fc6b2db9b",
        "name": IDS.LRI_HPL_LAND,
        "provenance": "8772bc77-560b-48e4-a886-22f8490bf6dc",
        "description": "8bfe7a87-387e-4121-8b04-206d0221f5ac"
    },
    {
        "id": "f878436c-e91b-4311-86e7-aeda20dd4655",
        "name": IDS.LRI_HPL_LAND,
        "provenance": "8772bc77-560b-48e4-a886-22f8490bf6dc",
        "description": "8bfe7a87-387e-4121-8b04-206d0221f5ac"
    },
    {
        "id": "5819e3ee-2110-4083-a322-851ebb493268",
        "name": "ecosys_wateryield",
        "provenance": "d8e86d38-9791-4491-ad21-c0e30f05318a"
    },
    {
        "id": "5b077c0c-dd65-4b95-9e3e-14969405ad7c",
        "name": "lri_rock_group",
        "provenance": "8772bc77-560b-48e4-a886-22f8490bf6dc",
        "description": "4f4ee972-20e0-45d5-8e90-435d33c863ef"
    },
    {
        "id": "63e7e247-3748-4fb5-a834-f2e6da6d8dd2",
        "name": "ecosys_nleach",
        "provenance": "1733a393-e289-4c9f-b437-851f0617e5d0"
    },
    {
        "id": "670e7d2b-e266-448a-9879-a6bea3b0e239",
        "name": "ecosys_sedtlost",
        "provenance": "3e695fca-a262-41b0-bfce-73b6de474370"
    },
    {
        "id": "6852437c-f3e3-459f-9119-4bb2915a6728",
        "name": "lri_observed_erosion",
        "provenance": "8772bc77-560b-48e4-a886-22f8490bf6dc",
        "description": "e975063a-02fc-47d3-b03f-90e310dd57ec"
    },
    {
        "id": "6a6cd326-3742-4fe1-9bdc-a4f6b957b526",
        "name": "lenz_tec",
        "provenance": "365247cf-ac92-4e17-9309-c0687b1daeaa",
        "description": "27bb1887-a6f9-4e94-8748-f64db10addd1"
    },
    {
        "id": "72ee867d-a20e-44c0-ac57-09b994149475",
        "name": "lri_arable_suitability",
        "provenance": "8772bc77-560b-48e4-a886-22f8490bf6dc",
        "description": "110171e9-d866-4860-9b5d-1980feb316ab"
    },
    {
        "id": "7768197a-bc2a-470b-ada9-eda9403466ac",
        "name": "slope",
        "provenance": "2b9add94-2d07-4661-8459-a49d10d7b5cc",
        "description": "3abbed99-c528-425b-81b0-a7573d725395"
    },
    {
        "id": "7ebedabb-be04-4d54-9775-6a48e6d514d4",
        "name": "lri_observed_erosion",
        "provenance": "8772bc77-560b-48e4-a886-22f8490bf6dc",
        "description": "e975063a-02fc-47d3-b03f-90e310dd57ec"
    },
    {
        "id": "83cacef0-0c6a-4f1a-853f-85368d31a7f0",
        "name": "ecosys_sedtretained",
        "provenance": "bf3a5391-76c1-4e78-86e5-4a12e195e499"
    },
    {
        "id": "863e2977-46cd-4ee2-84b8-4c8a18ef2bc3",
        "name": "lri_general_suitability",
        "provenance": "8772bc77-560b-48e4-a886-22f8490bf6dc",
        "description": "cb8d3240-dcca-4e6f-acaa-e09941cce5e7"
    },
    {
        "id": "90abee75-21f2-4cee-a6fe-76b8b577e7c0",
        "name": "lri_rock_group",
        "provenance": "8772bc77-560b-48e4-a886-22f8490bf6dc",
        "description": "4f4ee972-20e0-45d5-8e90-435d33c863ef"
    },
    {
        "id": "921470f0-72bb-478e-a760-66e6372e28f0",
        "name": "wetlands_current,wetlands_historic",
        "provenance": "b39ab2ca-1f4c-44c0-8fd3-f23b1f4c88b6",
        "description": "ef0ef9d5-9b15-4db2-9fb0-65531dee505f"
    },
    {
        "id": "96e55b7c-e9dc-4b7f-9236-e847aed43b74",
        "name": "aspect_slope",
        "provenance": "2b9add94-2d07-4661-8459-a49d10d7b5cc",
        "description": "654af486-0b77-43db-82ab-b2a9601ba2b3"
    },
    {
        "id": "a1740420-1776-4bcd-a8c0-bcdb8bc408a3",
        "name": "lri_arable_suitability",
        "provenance": "8772bc77-560b-48e4-a886-22f8490bf6dc",
        "description": "110171e9-d866-4860-9b5d-1980feb316ab"
    },
    {
        "id": "a9756de6-b01a-490f-8588-9a416c1560b4",
        "name": "ecosys_ghg",
        "provenance": "8b67b46b-283b-4310-92fd-d1dc26e067be"
    },
    {
        "id": "ac817de1-22ae-4af8-b868-150c61535f0f",
        "name": "ecosys_sedtretained",
        "provenance": "bf3a5391-76c1-4e78-86e5-4a12e195e499"
    },
    {
        "id": "ae48f295-b3e7-4828-a992-e82868b5512c",
        "name": "wetlands_current,wetlands_historic",
        "provenance": "b39ab2ca-1f4c-44c0-8fd3-f23b1f4c88b6",
        "description": "ef0ef9d5-9b15-4db2-9fb0-65531dee505f"
    },
    {
        "id": "b26f5515-bb08-437c-9153-e1b5f88a1358",
        "name": "lri_phys_sustain",
        "provenance": "8772bc77-560b-48e4-a886-22f8490bf6dc",
        "description": "f3d8cfe7-ab36-480d-a149-3893c326e8e4"
    },
    {
        "id": "b5c01f73-9107-4d86-8b76-06e3ecd2e3fe",
        "name": "lenz_potnatveg",
        "provenance": "1389f8a3-f625-46c0-9b7a-272242409342",
        "description": "7e6abb2d-bbc8-4c7e-9180-eea4cdc1e914"
    },
    {
        "id": "b8ea9e9b-7d8f-4225-80e4-69128d637e83",
        "name": "slope",
        "provenance": "2b9add94-2d07-4661-8459-a49d10d7b5cc",
        "description": "3abbed99-c528-425b-81b0-a7573d725395"
    },
    {
        "id": "bdfaeba1-4aa1-43d3-abc9-0c9f65e539d3",
        "name": "ecosys_basic_eco",
        "provenance": "fca31715-13b9-4f82-a9ae-118977f13ccd"
    },
    {
        "id": "c0165ff6-cd28-429d-b05d-990afadcdf96",
        "name": "lenz_prot_areas",
        "provenance": "13d667bb-2d51-4dd1-91f1-cebbc6d9f27a",
        "description": "2b0527d9-527a-4c11-a2d3-1f599261f44a"
    },
    {
        "id": "c04601b0-d1fb-44ca-bf63-b0325df1aa7d",
        "name": "ecosys_basic_eco",
        "provenance": "fca31715-13b9-4f82-a9ae-118977f13ccd"
    },
    {
        "id": "c5c90177-2660-483b-a61c-835dcde379bf",
        "name": "lenz_potnatveg",
        "provenance": "1389f8a3-f625-46c0-9b7a-272242409342",
        "description": "7e6abb2d-bbc8-4c7e-9180-eea4cdc1e914"
    },
    {
        "id": "cfd7ba3d-5395-4574-9b1c-a9b55bcc024c",
        "name": "lri_phys_sustain",
        "provenance": "8772bc77-560b-48e4-a886-22f8490bf6dc",
        "description": "f3d8cfe7-ab36-480d-a149-3893c326e8e4"
    },
    {
        "id": "d87bca6d-9aca-456f-8792-a428dd5f3c2e",
        "name": "lcdb5_veg",
        "provenance": "125b5bad-f339-48d0-8861-3d599b9126a9",
        "description": "92af14b8-3ed8-4cc5-8657-acf5bc736080"
    },
    {
        "id": "d8c9f5ac-7f1c-4526-beec-29c1ba8dea36",
        "name": "lri_luc_main",
        "provenance": "8772bc77-560b-48e4-a886-22f8490bf6dc",
        "description": "112fdbff-f3a0-44a8-903d-033a6f369e21"
    },
    {
        "id": "e758f4a2-d23b-4fd5-a466-30d0d79203b9",
        "name": "lri_prod_for_suitability",
        "provenance": "8772bc77-560b-48e4-a886-22f8490bf6dc",
        "description": "c6e504cf-2463-419a-bf7d-fed220e119dc"
    },
    {
        "id": "ef34af96-791e-4bea-9f0e-27f0594051ee",
        "name": "aspect_slope",
        "provenance": "2b9add94-2d07-4661-8459-a49d10d7b5cc",
        "description": "654af486-0b77-43db-82ab-b2a9601ba2b3"
    },
    {
        "id": "ef6c8b9c-15a6-4ac7-ba18-261afa881e84",
        "name": null
    },
    {
        "id": "ff653425-1af7-4f50-9a1f-ba7598905319",
        "name": "ecosys_sedtlost",
        "provenance": "3e695fca-a262-41b0-bfce-73b6de474370"
    },
    ...suitabilityMetadata.topicMetadata,
    // additional area report topics
    {
        "id": "a3960fe1-1641-4658-9d88-c10351ceea44",
        "name": "eswwo_susceptibility_to_n_loss_horiz",
        "description": "04c574cc-ad8d-456b-86dd-9b0a2d74d545"
    },
    {
        id: "3be359d9-6754-44d6-aef7-f6958335f9de",
        name: "eswwo_susceptibility_to_n_loss_vert",
        description: "aa101242-316e-4739-a559-94034fd23bb7"
    },
    {
        id: "75def429-195f-4155-a62b-df0264950bb8",
        name: "eswwo_dairy_max_n",
        description: "52041e97-96db-4da6-8248-828d91a00544"
    },
    {
        id: "ae44ec43-c688-4839-8fc9-0762890edf0b",
        name: "eswwo_dairy_max_n2o",
        description: "36a56b5d-1232-4fa2-af41-1efcae31dec0"
    },
    {
        id: "6a2ec580-05f9-462e-9b02-73e881563e73",
        name: "eswwo_nleachloss_maize_grass",
        description: "3250289c-145d-417f-83dc-26c15be7f7e8"
    },
    {
        id: "192dfa15-3013-470c-ae2f-185496617d28",
        name: "eswwo_nleachloss_intensive_veggies",
        description: "612b7000-838c-42e0-896c-dedd6c03abe3"
    },
    {
        id: "3abca607-4451-420c-8db9-3f637d6c1838",
        name: "eswwo_nleachloss_broadacre_veggies",
        description: "7a87fb25-d546-49d4-ad62-6b6e34b2d6cc"
    },
    {
        id: "07a8994f-411a-4b55-9525-7d64e10c28f1",
        name: "eswwo_ecoli_exyldpct",
        description: "4b3ff977-aa54-4092-b511-dbddf24c0426"
    },
    {
        id: "4ae1cb51-0e9b-4582-889a-c1ee7091f07b",
        name: "eswwo_nutr_tn_exyldpct",
        description: "e746679e-5e75-4b81-8893-df8828a69734"
    },
    {
        id: "9150f512-78be-4141-a6c3-8a270000cc5f",
        name: "eswwo_nutr_tp_exyldpct",
        description: "9d6dcf77-7379-442a-bcff-21f2b73a49b7"
    },
    {
        id: "eedb796f-f6e1-49cb-a67e-7e0504f7da88",
        name: "eswwo_sedi_exyldpct",
        description: "70808415-ee8d-48a2-a583-45bf8c34f51b"
    },
    // additional pin report topics
    {
        "id": "a74435d2-1510-4b82-af7d-b98ceace1e3a",
        "name": "eswwo_susceptibility_to_n_loss_horiz",
        "description": "04c574cc-ad8d-456b-86dd-9b0a2d74d545"
    },
    {
        id: "04f1e8d4-ae5a-4e34-b1c5-29d38458e174",
        name: "eswwo_susceptibility_to_n_loss_vert",
        description: "aa101242-316e-4739-a559-94034fd23bb7"
    },
    {
        id: "300d123e-8501-4d67-b6a0-8763f44af54a",
        name: "eswwo_dairy_max_n",
        description: "52041e97-96db-4da6-8248-828d91a00544"
    },
    {
        id: "8a8f28bf-caea-433f-8133-424734defccb",
        name: "eswwo_dairy_max_n2o",
        description: "36a56b5d-1232-4fa2-af41-1efcae31dec0"
    },
    {
        id: "148e5253-bef3-47ae-a1b3-bbafb8f89de1",
        name: "eswwo_nleachloss_maize_grass",
        description: "3250289c-145d-417f-83dc-26c15be7f7e8"
    },
    {
        id: "7827005d-056e-45a0-9bae-3f7805c6c1f8",
        name: "eswwo_nleachloss_intensive_veggies",
        description: "612b7000-838c-42e0-896c-dedd6c03abe3"
    },
    {
        id: "b1406449-4ae9-403f-a80d-8eaa4174c537",
        name: "eswwo_nleachloss_broadacre_veggies",
        description: "7a87fb25-d546-49d4-ad62-6b6e34b2d6cc"
    },
    {
        id: "30bfbec0-9ce8-4a23-aef0-11e597f54706",
        name: "eswwo_ecoli_exyldpct",
        description: "4b3ff977-aa54-4092-b511-dbddf24c0426"
    },
    {
        id: "e70901bf-3dd5-4876-92b1-3e5a9c620462",
        name: "eswwo_nutr_tn_exyldpct",
        description: "e746679e-5e75-4b81-8893-df8828a69734"
    },
    {
        id: "fa2b40f6-b0c6-4206-9d4c-663c75a923bd",
        name: "eswwo_nutr_tp_exyldpct",
        description: "9d6dcf77-7379-442a-bcff-21f2b73a49b7"
    },
    {
        id: "361e9e62-8bf7-4034-8aca-ecfa0a607f71",
        name: "eswwo_sedi_exyldpct",
        description: "70808415-ee8d-48a2-a583-45bf8c34f51b"
    }
];

export function topicByName(topicName) {
    return topicMetadata.find(({name}) => name === topicName);
}

export const metadataCollections = [
    {
        id: "04c574cc-ad8d-456b-86dd-9b0a2d74d545",
        title: "Phosphorous loss susceptibility",
        metadata: [
            {
                title: "Phosphorous loss susceptibility",
                description: "<p>This layer provides a representation of the annual mean susceptibility of phosphorus loss, considering soil and climate factors at each pixel. It focuses on the horizontal movement of phosphorus due to rainfall and soil moisture. The data was derived from the Agricultural Production Systems Simulator (APSIM) model, which simulated phosphorus loss from a urine patch in a continuous ryegrass/white clover mixed pasture setup.</p><p>The spatial resolution of this dataset is based on a 5km climate grid, using the Fundamental Soil Layers and S-map soil polygons. It is important to note that this analysis does not take into account land use or actual nutrient inputs, focusing solely on inherent soil and climatic conditions. The resulting susceptibility values are scaled between 0 and 1, providing an indication of the relative level of nitrate filtering function at each location.</p>"
            }
        ]
    },
    {
        id: "aa101242-316e-4739-a559-94034fd23bb7" ,
        title: "Nitrogen loss susceptibility",
        metadata: [
            {
                title: "Nitrogen loss susceptibility",
                description: "<p>This layer provides a representation of the annual mean susceptibility of nitrogen loss, considering soil and climate factors at each pixel. It focuses on the vertical movement of nitrogen due to rainfall and soil moisture. The data was derived from the Agricultural Production Systems Simulator (APSIM) model, which simulated nitrogen loss from a urine patch in a continuous ryegrass/white clover mixed pasture setup.</p><p>The spatial resolution of this dataset is based on a 5km climate grid, using the Fundamental Soil Layers and S-map soil polygons. It is important to note that this analysis does not take into account land use or actual nutrient inputs, focusing solely on inherent soil and climatic conditions. The resulting susceptibility values are scaled between 0 and 1, providing an indication of the relative level of nitrate filtering function at each location.</p>"
            }
        ]
    },
    {
        id: "52041e97-96db-4da6-8248-828d91a00544",
        title: "Dairy nitrogen loss",
        metadata: [
            {
                title: "Dairy nitrogen loss",
                description: "<p>This layer represents the estimated maximum potential nitrogen leaching losses if the land were under dairy farming. It does not represent the actual land use at each location. Land that is unsuitable for dairy e.g. too steep, is masked out. The data is derived from a spatial layer that includes various dairy types characterised by specific climate, slope, and soil properties. Nitrogen loss rates are estimated using the Overseer® Nutrient Budgeting software (version 6.5.0), which models nitrogen run-off and leaching below the root zone from livestock urine patches and other non-urine sources such as fertiliser or soil mineralisation.</p><p>The data reflects the 2019-2020 production year, based on DairyBase data. Soil data from S-map and FSL, slope data from a 15m DEM, and climate data were used to develop this layer. Nitrogen losses are reported in kg N per hectare per year.</p>"
            }
        ]
    },
    {
        id: "36a56b5d-1232-4fa2-af41-1efcae31dec0",
        title: "Dairy N₂O emissions",
        metadata: [
            {
                title: "Dairy N₂O emissions",
                description: "<p>This layer represents the estimated maximum potential nitrous oxide (N₂O) emissions if the land were under dairy farming. It does not represent the actual land use at each location. Land that is unsuitable for dairy e.g. too steep, is masked out. The emissions data is derived from a spatial layer that includes different dairy types characterised by climate, slope, and soil properties. The Overseer® Nutrient Budgeting software (version 6.5.0) models nitrous oxide emissions, which are reported as CO₂ equivalents (kg CO₂e per hectare per year) using a 100-year time horizon global warming potential of 298 kg CO₂-equivalent per kg N₂O.</p><p>The data reflects the 2019-2020 production year, based on DairyBase data. Nitrous oxide emission estimates are annual averages based on updated farm nutrient budgets with data from DairyNZ DairyBase baseline farm records. Soil data from S-map and FSL, slope data derived from a 15m DEM, and climate data were utilised.</p>"
            }
        ]
    },
    {
        id: "3250289c-145d-417f-83dc-26c15be7f7e8",
        title: "Estimated Nitrogen Leaching - Ryegrass and Silage Maize",
        metadata: [
            {
                title: "Estimated Nitrogen Leaching - Ryegrass and Silage Maize",
                description: "<p>This layer represents the estimated potential nitrogen leaching losses if the land were under ryegrass and silage maize crop rotations. It does not represent the actual land use at each location. Land that is unsuitable for ryegrass and silage maize is masked out. The data is derived from Agricultural Production Systems Simulator (APSIM) simulations, which model nitrogen leaching based on soil and climate conditions under different irrigation and fertiliser management scenarios.</p><p>The simulations encompass six scenarios:</p><ol><li>Irrigation to fully overcome soil water deficit with fixed fertiliser schedule.</li><li>Irrigation to fully overcome soil water deficit with flexible fertiliser management based on soil N status.</li><li>Irrigation managed to maintain a soil water deficit with fixed fertiliser schedules.</li><li>Irrigation managed to maintain a soil water deficit with flexible fertiliser management based on soil N status.</li><li>No irrigation and fixed fertiliser schedule.</li><li>No irrigation with flexible fertiliser management based on soil N status.</li></ol><p>The map layer displayed shows nitrogen leaching losses for the 'Irrigation to fully overcome soil water deficit with fixed fertiliser schedule' scenario. Users can access additional scenario data via the GET REPORTS panel by dropping a pin on the map, which will return data for all irrigation and fertilisation scenarios.</p><p>The simulations span a 30-year period (1980-2010), using daily weather data from NIWA's Virtual Climate Station Network and soil data from S-map and the Fundamental Soil Layers (FSL). The methodology includes assumptions about idealised management practices and homogeneous application of water and nitrogen, ensuring no restrictions on resource access or management efficiency.</p>"
            }
        ]
    },
    {
        id: "612b7000-838c-42e0-896c-dedd6c03abe3",
        title: "Estimated Nitrogen Leaching - Intensive Vegetables",
        metadata: [
            {
                title: "Estimated Nitrogen Leaching - Intensive Vegetables",
                description: "<p>This layer represents the estimated potential nitrogen leaching losses if the land were under intensive vegetable crop rotations. It does not represent the actual land use at each location. Land that is unsuitable for intensive vegetable cropping is masked out. The data is derived from Agricultural Production Systems Simulator (APSIM) simulations, which model nitrogen leaching based on soil and climate conditions under different irrigation and fertiliser management scenarios. Intensive crop rotation includes vegetables like lettuce, cabbage, spinach, cauliflower, and oats.</p><p>The simulations encompass six scenarios:</p><ol><li>Irrigation to fully overcome soil water deficit with fixed fertiliser schedule.</li><li>Irrigation to fully overcome soil water deficit with flexible fertiliser management based on soil N status.</li><li>Irrigation managed to maintain a soil water deficit with fixed fertiliser schedules.</li><li>Irrigation managed to maintain a soil water deficit with flexible fertiliser management based on soil N status.</li><li>No irrigation and fixed fertiliser schedule.</li><li>No irrigation with flexible fertiliser management based on soil N status.</li></ol><p>The map layer displayed shows nitrogen leaching losses for the 'Irrigation to fully overcome soil water deficit with fixed fertiliser schedule' scenario. Users can access additional scenario data via the GET REPORTS panel by dropping a pin on the map, which will return data for all irrigation and fertilisation scenarios.</p><p>The simulations span a 30-year period (1980-2010), using daily weather data from NIWA's Virtual Climate Station Network and soil data from S-map and the Fundamental Soil Layers (FSL). The methodology includes assumptions about idealised management practices and homogeneous application of water and nitrogen, ensuring no restrictions on resource access or management efficiency.</p>"
            }
        ]
    },
    {
        id: "7a87fb25-d546-49d4-ad62-6b6e34b2d6cc",
        title: "Estimated Nitrogen Leaching - Broadacre Vegetables",
        metadata: [
            {
                title: "Estimated Nitrogen Leaching - Broadacre Vegetables",
                description: "<p>This layer represents the estimated potential nitrogen leaching losses if the land were under broadacre vegetable crop rotations. It does not represent the actual land use at each location. Land that is unsuitable for broadacre vegetable cropping is masked out. The data is derived from Agricultural Production Systems Simulator (APSIM) simulations, which model nitrogen leaching based on soil and climate conditions under different irrigation and fertiliser management scenarios. Broadacre crop rotation includes vegetables like squash, onions, beetroot, sweetcorn, beans, and oats.</p><p>The simulations encompass six scenarios:</p><ol><li>Irrigation to fully overcome soil water deficit with fixed fertiliser schedule.</li><li>Irrigation to fully overcome soil water deficit with flexible fertiliser management based on soil N status.</li><li>Irrigation managed to maintain a soil water deficit with fixed fertiliser schedules.</li><li>Irrigation managed to maintain a soil water deficit with flexible fertiliser management based on soil N status.</li><li>No irrigation and fixed fertiliser schedule.</li><li>No irrigation with flexible fertiliser management based on soil N status.</li></ol><p>The map layer displayed shows nitrogen leaching losses for the 'Irrigation to fully overcome soil water deficit with fixed fertiliser schedule' scenario. Users can access additional scenario data via the GET REPORTS panel by dropping a pin on the map, which will return data for all irrigation and fertilisation scenarios.</p><p>The simulations span a 30-year period (1980-2010), using daily weather data from NIWA's Virtual Climate Station Network and soil data from S-map and the Fundamental Soil Layers (FSL). The methodology includes assumptions about idealised management practices and homogeneous application of water and nitrogen, ensuring no restrictions on resource access or management efficiency.</p>"
            }
        ]
    },
    {
        id: "4b3ff977-aa54-4092-b511-dbddf24c0426",
        title: "E. coli excess load",
        metadata: [
            {
                title: "E. coli excess load",
                description: "<p>This layer indicates the necessary load reduction to achieve at least the NOF (National Objectives Framework) C-band for E. coli levels in critical catchments. The NOF C-band, part of New Zealand's freshwater management framework, ensures water quality suitable for secondary contact recreation, such as boating and wading.</p><p>The map layer visualises the yield proportion, which is calculated by dividing the E. coli load (expressed as giga E. coli organisms per hectare per year (Giga E. coli/ha/yr)) by the catchment area. The yield proportion is used to show the reduction required, expressed as a percentage of the current E. coli yield. For example, if a catchment currently yields a certain amount of E. coli per hectare per year, this layer shows the proportion of that yield which must be reduced to meet the NOF C-band standard.</p><p>The underlying data was derived using spatial statistical models to compare predicted E. coli concentrations against criteria defined by the NPSFM (National Policy Statement for Freshwater Management). The analysis spans a 5-year period from 2016 to 2020, providing average annual loads and focused on reducing excess E. coli loads to meet the NOF C-band. The data is based on the digital river network used by the River Environment Classification (REC).</p><p>N.B. Data has been clipped using LINZ 1:250k lakes, therefore the map will show no data and there will be no reporting over these areas.</p>"
            }
        ]
    },
    {
        id: "e746679e-5e75-4b81-8893-df8828a69734",
        title: "Nitrogen excess load",
        metadata: [
            {
                title: "Nitrogen excess load",
                description: "<p>This layer represents the load reduction required to achieve at least the NOF (National Objectives Framework) C-band for total nitrogen (TN) levels in critical catchments. The NOF C-band ensures water quality that supports secondary contact recreation, such as boating and wading, by maintaining moderate nutrient levels.</p><p>The map layer visualises the yield proportion, which is calculated by dividing the nitrogen load (expressed in kilograms of total nitrogen per hectare per year (kg TN/ha/yr)) by the catchment area. The yield proportion is used to show the reduction required, expressed as a percentage of the current TN load. For example, if a catchment currently yields a certain amount of nitrogen per hectare per year, this layer shows the proportion of that yield which must be reduced to meet the NOF C-band standard.</p><p>Derived from spatial statistical models, the underlying dataset uses compared predicted TN concentrations against the NPSFM (National Policy Statement for Freshwater Management) nutrient target states. The analysis spans a 5-year period from 2016 to 2020, providing average annual loads and focused on reducing excess TN loads to meet the NOF C-band. The data is based on the digital river network used by the River Environment Classification (REC).</p><p>N.B. Data has been clipped using LINZ 1:250k lakes, therefore the map will show no data and there will be no reporting over these areas.</p>"
            }
        ]
    },
    {
        id: "9d6dcf77-7379-442a-bcff-21f2b73a49b7",
        title: "Phosphorus excess load",
        metadata: [
            {
                title: "Phosphorus excess load",
                description: "<p>This layer represents the load reduction required to achieve at least the NOF (National Objectives Framework) C-band for total phosphorus (TP) levels in critical catchments. The NOF C-band ensures water quality suitable for secondary contact recreation, such as boating and wading, by maintaining moderate nutrient levels.</p><p>The map layer visualises the yield proportion, which is calculated by dividing the phosphorus load (expressed in kilograms of total phosphorus per hectare per year (kg TP/ha/yr)) by the catchment area. The yield proportion is used to show the reduction required, expressed as a percentage of the current TP load. For example, if a catchment currently yields a certain amount of phosphorus per hectare per year, this layer shows the proportion of that yield which must be reduced to meet the NOF C-band standard.</p><p>Derived from spatial statistical models, the underlying dataset uses compared predicted TP concentrations against the NPSFM (National Policy Statement for Freshwater Management) nutrient target states. The analysis spans a 5-year period from 2016 to 2020, providing average annual loads and focused on reducing excess TP loads to meet the NOF C-band. The data is based on the digital river network used by the River Environment Classification (REC).</p><p>N.B. Data has been clipped using LINZ 1:250k lakes, therefore the map will show no data and there will be no reporting over these areas.</p>"
            }
        ]
    },
    {
        id: "70808415-ee8d-48a2-a583-45bf8c34f51b",
        title: "Sediment excess load",
        metadata: [
            {
                title: "Sediment excess load",
                description: "<p>This layer represents the load reduction required to achieve at least the NOF (National Objectives Framework) C-band for sediment levels in critical catchments. The NOF C-band ensures water quality suitable for secondary contact recreation, such as boating and wading, by maintaining moderate sediment levels.</p><p>The map layer visualises the yield proportion, which is calculated by dividing the sediment load (expressed in tonnes of sediment per square kilometer per year (t/km²/yr)) by the catchment area. The yield proportion is used to show the reduction required, expressed as a percentage of the current sediment yield. For example, if a catchment currently yields a certain amount of sediment per square kilometer per year, this layer shows the proportion of that yield which must be reduced to meet the NOF C-band standard.</p><p>This dataset is based on spatial statistical models comparing predicted sediment concentrations against the National Bottom Lines for visual clarity and sediment loads in New Zealand's river environments. The analysis spans a 5-year period from 2016 to 2020, providing average annual loads and focused on reducing excess sediment loads to meet the NOF C-band. The data is based on the digital river network used by the River Environment Classification (REC).</p><p>N.B. Data has been clipped using LINZ 1:250k lakes, therefore the map will show no data and there will be no reporting over these areas.</p>"
            }
        ]
    },
    {
        "id": "110171e9-d866-4860-9b5d-1980feb316ab",
        "title": "Suitability for Arable Cropping",
        "metadata": [
            {
                "title": "Suitability for Arable Cropping",
                "description": "<p>Classification of land according to suitability for arable cropping. This classification has been carried out using the New Zealand Land Resource Inventory (NZLRI) Land Use Capability (LUC) rating. LUC rates the ability of land to sustain agricultural production, based on an assessment of NZLRI factors, climate, the effects of past land use, and the potential for erosion.<br><br>The data in this layer was collected over an extended time period. Most of South Island was mapped between 1971 and 1979. In the North Island, Northland was mapped between 1985-1990, Wellington between 1987-1992, Marlborough between 1989-1993 and Gisborne East Coast between 1995-1998. The rest of the North Island was mapped between 1971 and 1979.</p>"
            }
        ]
    },
    {
        "id": "112fdbff-f3a0-44a8-903d-033a6f369e21",
        "title": "Land Use Capability",
        "metadata": [
            {
                "title": "Land Use Capability\n",
                "description": "<p>The Land Use Capability system categorizes land into eight classes according to its long-term capability to sustain one or more productive uses based on physical limitations and site specific management needs. Productive capacity depends on physical qualities of the land, soil and environment. Differences between ideal and actual land qualities may be regarded as limitations which will affect productivity and land management options. Limitations considered in the LUC include: susceptibility to erosion, steepness of slope, climate, susceptibility to flooding, liability to wetness or drought, salinity, and depth, texture, structure and nutrient supply of the soil. Note that complex map units containing two LUC units may occur. In this case reports provided will describe the dominant LUC unit only.</p>"
            }
        ]
    },
    {
        id: "8bfe7a87-387e-4121-8b04-206d0221f5ac",
        title: "Baseline Highly Productive Land",
        "metadata": [
            {
                title: "Baseline Highly Productive Land",
                description: `<p>This layer is a visualisation of the baseline extent of Highly Productive Land, represented here as Land Use
    Capability classes 1, 2 and 3, as mapped in the New Zealand Land Resource Inventory. The actual boundaries of Highly
    Productive Land in a particular location will differ to this visualisation, depending on the relevant council rural
    and urban zoning boundaries as defined in the National Policy Statement for Highly Productive Land (refer to clause
    3.5). Please refer to your local council for this information.</p>
<p>By late 2025 it is expected that each
    regional council will also have remapped the extent of Highly Productive Land for their region, following the
    requirements in the National Policy Statement for Highly Productive Land (refer to clause 3.4). When this is done
    that updated regional map will replace the map presented here. Please refer to your local council for this
    information.</p>
<p>Full information on the National Policy Statement for Highly Productive Land is available
    <a target="_blank" rel="noopener"
       href="https://www.mpi.govt.nz/agriculture/farm-management-the-environment-and-land-use/national-policy-statement-for-highly-productive-land-2022/">here.</a>
</p>
<p>
    For full definition and description please refer to the
    <a target="_blank" rel="noopener"
       href="https://digitallibrary.landcareresearch.co.nz/digital/collection/p20022coll14/id/74/">Land Use Capability Survey Handbook.</a>
</p>`
            }
        ]
    },
    {
        "id": "125b5bad-f339-48d0-8861-3d599b9126a9",
        "title": "Land Cover Database (LCDB v5.0)",
        "metadata": [
            {
                "title": "Land Cover Database (LCDB v4.1)",
                "description": `<p>A New Zealand Land Cover Database has been prepared five times from imagery collected in&nbsp;<span>summer 1996/97, summer 2001/02, summer 2008/09, summer 2012/13, and summer 2018/19</span> as part of New Zealand's response to climate change and the Kyoto Protocol. The data used in Our Environment are taken from LCDB v5.0, published in January 2020, and are made available by Manaaki Whenua under a Creative Commons license. A number of metadata documents are available and those using the LCDB v5.0 should be familiar with this material. These include a User Guide and documents defining Target Classes that can be found on the <a href="https://lris.scinfo.org.nz/layer/104400-lcdb-v50-land-cover-database-version-50-mainland-new-zealand/">LRIS Portal</a>.</p>
<p>LCDB v5.0 is a thematic classification of 33 land-cover and land-use classes covering mainland New Zealand, the near shore islands (<span>re-mapping of Chatham Islands was included in version 4.1 - first mapped at version 2, but then not continued through versions 3.0, 3.3, and 4.0 because of resource constraints</span>). LCDB v5.0 was released in&nbsp;January 2020 and used Landsat 7 ETM+ satellite imagery acquired over the summer of 2018/20. Like LCDB1, LCDB2, LCDB v3.3 and LCDB v4.1, LCDB v5.0 adopted a one hectare (ha) minimum mapping unit (MMU) and to maintain compatibility between datasets for change analysis. Users should be aware of the following issues in using geospatial data derived from imagery with a 15m spatial resolution:</p>
<ul>
<li><strong><em>Positional accuracy:</em></strong>&nbsp;In areas with good ground control the Landsat imagery is correct to within 1 pixel. In areas with poor control (typically mountainous terrain) the imagery may have a positional error of 2 or more pixels.</li>
<li><strong><em>Linework accuracy:</em></strong>&nbsp;LCDB2 had polygon boundaries created using both automated and manual digitising techniques (at a display screen resolution of 1:15,000). Cartographically this resulted in a mixture of 'rasterised' and smooth polygons. The raster effect becomes noticeable at 1:25000. Given the spatial resolution, ortho-rectification error and scale of manual digitising of LCDB, procedures were introduced to automatically smooth polygon boundaries to create a consistent cartographic standard of representation. Good practice indicates use of LCDB at a scale of 1:25,000 or smaller scales (i.e. 1:50,000).</li>
<li><strong><em>Dominant cover rule:</em></strong>&nbsp;Users need to be aware of the dominant cover rule. For example, regenerating Indigenous Forest is classified as Class 69 (Indigenous Forest), providing more than 50% of the patch is characterised by emergent canopy species. A Shrubland polygon with three or more main species (where further subdivision of the patch based on the 1 ha MMU is not possible), is classified according to the dominant species in the matrix.</li>
</ul>
<p>There was no official accuracy assessment of LCDB v5.0. For LCDB2 a Marlborough pilot study included an accuracy assessment, but this may or may not be applicable to the full dataset. A paper by&nbsp;Brockerhoff et al.&nbsp;(2008) in the New Zealand Journal of Ecology has useful information on class accuracy of LCDB2 (and LCDB1).</p>
<p><em>The interpretation in Our Environment based on the LCDB v5.0 and therefore subject to its data accuracy is: Vegetation.</em></p>`
            }
        ]
    },
    {
        "id": "1389f8a3-f625-46c0-9b7a-272242409342",
        "title": "Potential Natural Vegetation",
        "metadata": [
            {
                "title": "Potential Natural Vegetation",
                "description": "<p>Potential natural vegetation (PNV) is a vector layer which provides an estimate of what New Zealand’s vegetation cover would have been in the absence of humans.&nbsp; It has been generated from largely raster data using statistical tools both for the interpolation of point climate data and the analysis of spatial patterns to reconstruct the likely biological character of New Zealand’s pre-human past. More information is available on the&nbsp;<a href=\"http://www.landcareresearch.co.nz/resources/maps-satellites/lenz\" target=\"_blank\">LENZ website</a>&nbsp;or in Leathwick, J. R. (2001), 'New Zealand's potential forest pattern as predicted from current species-environment relationships', New Zealand Journal of Botany 39: 447-464. The accuracy of this dataset is difficult to assess since it portrays a concept rather than something that exists in the real-world.&nbsp; In addition, because it is generated from a number of input layers which include climate layers derived by interpolation, there is significant potential for complex propagation of errors.&nbsp; Finally, the original raster data layer has also been converted to vectors with some smoothing and simplification of linework.&nbsp; For this reason the PNV layer cannot be viewed at scales larger than 1:50,000 scale.</p>"
            }
        ]
    },
    {
        "id": "13d667bb-2d51-4dd1-91f1-cebbc6d9f27a",
        "title": "Protected Natural Areas (PNA)",
        "metadata": [
            {
                "title": "Protected Natural Areas (PNA)",
                "description": "<p>This is a parcel-based vector dataset with elements of cadastral land parcels included in the conservation estate, covenants of the Nature Heritage Fund, Nga Whenua Rahui, and QE II National Trust, along with Regional Parks of Auckland, Bay of Plenty, Manawatu, and Wellington. Data accuracy equates closely to standards for property and in many cases will have been subject to land survey with coordinate accuracy well below metre accuracy.</p>\n<p><em>The interpretation in Our Environment based on the PNA and therefore subject to its data accuracy is: Protected Natural Areas.</em></p>"
            }
        ]
    },
    {
        "id": "1733a393-e289-4c9f-b437-851f0617e5d0",
        "title": "Nitrate Leaching (2015)",
        "metadata": [
            {
                "title": "Nitrate Leaching (2015)",
                "description": "<p><span>Nitrogen leaching was estimated using OVERSEER farm nutrient budgeting software version 5.4 (Ministry of Agriculture and Forestry et al., 2011) with a modifier to account for OVERSEER version 6. OVERSEER was run for the 100 combinations of soils and climate from level II of LENZ (Leathwick et al., 2003). Stocking rate were set to the carrying capacity of the land according to the New Zealand Land Resource Inventory (Landcare Research, 2011b), and annual leaching rate per stock unit calculated. The nitrogen leaching rates per stock unit were then combined with a map of modelled animal numbers to produce a map of nitrogen leaching for all of New Zealand. The spatial distribution of animal numbers (dairy, sheep, beef, and deer) was modelled using a land-use map derived from AgriBase (AgriQuality New Zealand, July 2015) and the land cover database 2012 (LCDB4.1, Manaaki Whenua, 2015). The number of animals were scaled using statistics of livestock numbers at the regional level (Agricultural Production Survey (APS), Statistics New Zealand, 2016) and spatially distributed the animals using the potential carrying capacity from fundamental soil layers (Landcare Research, 2011a). N.B. Deer numbers were missing from the APS data for 2015-16 for the Taranaki region which results in reduced GHG values for the region.</span></p>"
            }
        ]
    },
    {
        "id": "27bb1887-a6f9-4e94-8748-f64db10addd1",
        "title": "Threatened Environment Classification (2012)",
        "metadata": [
            {
                "title": "Threatened Environment Classification (2012)\n",
                "description": "<p>This layer comes from the Threatened Environment Classification (TEC) version 2012, which is a source of national scale background information on New Zealand's land environments. Specifically, it shows how much native (indigenous) vegetation remains within land environments, and how past vegetation loss and legal protection are distributed across New Zealand's landscape. The TEC uses indigenous vegetation as a surrogate for indigenous biodiversity. This includes indigenous ecosystems, habitats and communities: the indigenous species, subspecies and varieties that are supported by indigenous vegetation, and their genetic diversity. The TEC is most appropriately applied to help identify places that are priorities for formal protection against clearance and/or incompatible land-uses, and for ecological restoration to restore lost species, linkages and buffers. The TEC is a combination of three national databases: Land Environments New Zealand (LENZ), classes of the 4th Land Cover Database (LCDB4, based on 2012 satellite imagery) and the protected areas network (version 2012, reflecting areas legally protected for the purpose of natural heritage protection). <br><br> For more information see: Cieraad E, Walker S, Price R, Barringer J. 2015. An updated assessment of indigenous cover remaining and legal protection in New Zealand's land environments. New Zealand Journal of Ecology 39(2).</p>"
            }
        ]
    },
    {
        "id": "2b0527d9-527a-4c11-a2d3-1f599261f44a",
        "title": "Protected Areas Network (2007)",
        "metadata": [
            {
                "title": "Protected Areas Network (2007)\n",
                "description": "<p>Areas which are legally protected serve to safeguard biodiversity, native species and ecosystems. The Protected Areas Network covers 32.9% of NZ, and includes Department of Conservation Estate; Nature Heritage Fund, Nga Whenua Rahui & QE II National Trust covenants; Regional Parks - Auckland, EBOP, Horizons & Wellington. Areas not included are marine reserves, offshore islands, local reserves and private conservation areas (i.e. not legally protected).</p>"
            }
        ]
    },
    {
        "id": "2b9add94-2d07-4661-8459-a49d10d7b5cc",
        "title": "25m Digital Elevation Model (DEM)",
        "metadata": [
            {
                "title": "15m Digital Elevation Model (DEM)",
                "description": "<p>\n    Manaaki Whenua&nbsp;produced its national DEM at 15m postings from 1:50,000 scale topographic data, including 20m\n    contours, spot heights, lake shorelines and coastline data available from Land Information New Zealand (LINZ) using\n    the TOPOGRID functions available in ArcGIS (ESRI).  This DEM is exactly spatially aligned with the pixels in the\n    pan-sharpened Landsat ETM+ multispectral imagery and has been optimised for slope accuracy to produce accurate\n    standardized reflectance corrections to remove terrain shading effects from\n    <a target=\"_blank\" href=\"https://www.landcareresearch.co.nz/resources/maps-satellites/ecosat\">EcoSat</a>\n    data products. It is hydrologically consistent with the NIWA digital stream network and is useful for automatically\n    producing catchment boundaries on flat areas.  <!--The 15m DEM was generated-->\n</p>\n<p>\n    Aspect and slope surfaces derived from the 15m DEM are currently based on standard ESRI ArcGIS algorithms calculated\n    over a 3x3 cell neighbourhood.  Note that the common practice of assigning elevation, slope and aspect values to\n    specified locations by spatial intersection with DEMs or derivative layers should be\n    <span style=\"text-decoration: underline;\">&nbsp;treated with great caution.</span>\n    The preferred option should always be to use field measurement of site properties, if at all practicable. While\n    these DEM&ndash;based surfaces provide greatly improved definition of surface properties, sensitivity of many\n    environmental systems to topographic variation and the errors inherent in contour-derived DEMs make them better\n    suited to implementing models rather than as a source of specific data values.\n</p>\n<p>\n    <em>\n    Interpretations in Our Environment based on the 15m DEM and therefore subject to its data accuracy are: Direction of Slope (aspect) and Steepness of Slope.\n    </em>\n</p>"
            }
        ]
    },
    {
        "id": "365247cf-ac92-4e17-9309-c0687b1daeaa",
        "title": "Threatened Indigenous Environments",
        "metadata": [
            {
                "title": "Threatened Indigenous Environments",
                "description": "<p>The Threatened Environment Classification 2012 has been developed by&nbsp;<span>Manaaki Whenua</span> to help identify areas in which much reduced and poorly protected indigenous ecosystems are most likely to occur. It uses LENZ as a framework for representativeness of the abiotic environment. How much of the potential 'full range' remains in indigenous cover and how much is protected are calculated using the LCDB v4.0 and Protected Natural Areas of New Zealand (PNA-NZ) data layers. The&nbsp;<a title=\"Link to Guide for Threatened Indigenous Environments\" href=\"http://www.landcareresearch.co.nz/__data/assets/pdf_file/0012/106131/Threatened_Environment_Classification_2012.pdf\" target=\"_blank\">Guide for Users of the Threatened Indigenous Environments classification</a>&nbsp;provides the best available indication of methodology and data accuracy.</p>"
            }
        ]
    },
    {
        "id": "3abbed99-c528-425b-81b0-a7573d725395",
        "title": "Steepness of Slope",
        "metadata": [
            {
                "title": "Steepness of Slope",
                "description": "<p>Slope angle is calculated from the change in elevation over distance. In this case distance equals pixel size (resolution).  Slope angle is expressed in degrees from the horizontal. This slope data is generated using Manaaki Whenua's 15m resolution Digital Elevation Model (DEM) and moving a 3x3 pixel neighbourhood  across the DEM calculating the slope angle for each of the central pixels from the elevation differences to its neighbours.</p>"
            }
        ]
    },
    {
        "id": "3e695fca-a262-41b0-bfce-73b6de474370",
        "title": "Sediment Lost (2012)",
        "metadata": [
            {
                "title": "Sediment Lost (2012)",
                "description": "<p><span>This layer depicts estimated sediment/soil loss across New Zealand and was created using the NZeem erosion model. Erosion control is defined as the prevention of soil loss by an ecosystem. NZeem has been calibrated from sediment discharges measured in New Zealand rivers (Dymond et al., 2010). This model estimates the long-term mean erosion rate from all sources of erosion, both mass-movement and surficial, and accounts for all sizes of rainfall events. The model was run on the national datasets of rainfall, erosion terrains, and land cover to produce a national 1:50,000 scale map of long-term mean erosion rates. Dymond et al. (2010) assessed the accuracy of the model by comparing predictions of specific sediment discharge (assuming sediment delivery ratio of 1 everywhere) with available measurements and obtained a model efficiency of 0.64.</span></p>\n<p><em>The interpretation in Our Environment based&nbsp;generated using the NZeem erosion model, calibrated from sediment discharges measured in New Zealand rivers (Dymond et al., 2010)&nbsp;and therefore subject to the accuracy of those data is: Sediment Lost.</em></p>"
            }
        ]
    },
    {
        "id": "4f4ee972-20e0-45d5-8e90-435d33c863ef",
        "title": "Surface Geology",
        "metadata": [
            {
                "title": "Surface Geology",
                "description": "<p>Polygon layer delineating physiographic areas of relatively homogenous surface and near-surface lithology (rock type). Derived from stereo aerial photograph interpretation, field verification and measurement as part of the 1:63 360/1:50 000 scale New Zealand Land Resource Inventory.</p>"
            }
        ]
    },
    {
        "id": "654af486-0b77-43db-82ab-b2a9601ba2b3",
        "title": "Aspect / Slope",
        "metadata": [
            {
                "title": "Aspect / Slope",
                "description": "<p>This is an aspect-slope map, simultaneously showing the aspect and the degree of steepness of slope. Aspect is the main compass direction (North, North East, East, etc.) that a slope faces, and has been calculated using a 3x3 window around each pixel of an in-house 15m resolution Digital Elevation Model (DEM). Each aspect has been colour-coded, (e.g. blue for east, orange for west), and is measured in degrees (°) from north.  In addition to the aspect, degree of slope is also symbolized using saturation (brilliance of colour);the steeper the slope the brighter the colour.  For example, bright red corresponds to steep south-west facing slopes, while pale blue are shallow easterly facing slopes.<br><br>N.B. Feature information currently only returns the direction of slope, and not the slope angle itself - slope angle can be obtained from the dedicated “Steepness of Slope” layer.</p>"
            }
        ]
    },
    {
        "id": "7e6abb2d-bbc8-4c7e-9180-eea4cdc1e914",
        "title": "Potential Natural Vegetation",
        "metadata": [
            {
                "title": "Potential Natural Vegetation\n",
                "description": "<p>This layer describes the expected state of mature vegetation in the absence of human intervention, and looks to reconstruct the likely biological character of New Zealand's pre-human past.<br><br>The dataset was created by statistical tools, which were used for interpolation of point climate data and the analysis of spatial patterns. It builds on preliminary statistical modelling by Leathwick (2001), and newly available high-resolution environmental data layers, to reconstruct New Zealand's 'Potential Vegetation Pattern'.</p>"
            }
        ]
    },
    {
        "id": "8772bc77-560b-48e4-a886-22f8490bf6dc",
        "title": "LRI",
        "metadata": [
            {
                "title": "Land Resource Inventory (LRI)",
                "description": "<p>This is a single spatial (polygon) layer with national coverage that contains several physical resource themes: land use capability, lithology, soil, etc. In terms of geographical data accuracy the polygon boundaries were originally mapped at 1:63,360 scale, except where more recent mapping was carried out at 1:50,000 scale in Northland, Gisborne-East Coast, Wellington and Marlborough regions. This is regional scale mapping according to the<a title=\"Link to LUC survey Handbook\" href=\"https://digitallibrary.landcareresearch.co.nz/digital/collection/p20022coll14/id/74/\" target=\"_blank\">&nbsp;Land Use Capability Survey Handbook&nbsp;</a>(Edition 3). The minimum polygon size for the smallest area of interest in the LRI mapping was nominally 10 hectares, although some 2% of polygons fall below this threshold. Average polygon size for 1:63,360 scale mapping is 335 hectares, and for the more recent 1:50,000 scale mapping is 98 hectares, reflecting both increased mapping scale and improved standards of mapping.</p>\n<p>The LRI is a regional-scale database and caution should be used when using these data at larger scales.</p>\n<p>In addition to the geographical accuracy of the polygon boundaries, each resource theme is subject to uncertainties about the attributes (e.g., soil classification). Users should download and familiarise themselves with the relevant sections of the LRIS Spatial Data Layers Data Dictionary to ensure that the data are fit for their intended analysis. This is available for download&nbsp;<a title=\"Link to LRIS Data Dictionary download page\" href=\"https://lris.scinfo.org.nz/document/9162-lris-data-dictionary-v3/\" target=\"_blank\">from here</a> in the LRIS Portal.</p>\n<p><em>Interpretations in Our Environment based on the LRI and therefore subject to its data accuracy are: Erosion Severity, Surface Geology and all five of the land suitability classifications.</em></p>"
            }
        ]
    },
    {
        "id": "8b67b46b-283b-4310-92fd-d1dc26e067be",
        "title": "Greenhouse Gas Emissions (2010-2016)",
        "metadata": [
            {
                "title": "Greenhouse Gas Emissions (2010-2016)",
                "description": "<p>The current New Zealand greenhouse gas inventory derives implied emission factors that vary between animal types (Ministry for the Environment, 2010). The spatial distribution of animal numbers (dairy, sheep, beef, and deer) was modelled using a land-use map derived from AgriBase (AgriQuality New Zealand, July 2015) and the land cover database 2012 (LCDB4.1, Manaaki Whenua, 2015). The number of animals were scaled using statistics of livestock numbers at the regional level (Agricultural Production Survey (APS), Statistics New Zealand, 2016) and spatially distributed the animals using the potential carrying capacity from fundamental soil layers (Landcare Research, 2011a). N.B. Deer numbers were missing from the APS data for 2015-16 for the Taranaki region which results in reduced GHG values for the region. New Zealand-specific emissions factors were then applied using the IPCC (Intergovernmental Panel on Climate Change) methodology for the agriculture sector for methane and nitrous oxide emissions (Ministry for the Environment, 2010) as per method in Ausseil et al (2013).</p>"
            }
        ]
    },
    {
        "id": "92af14b8-3ed8-4cc5-8657-acf5bc736080",
        "title": "Vegetation",
        "metadata": [
            {
                "title": "Vegetation",
                "description": "<p>\n    This vegetation map was produced using the Land Cover Database Version 5 (LCDB5). LCDB5 is a multi-temporal, thematic classification of 33 land cover and land use classes designed to be compatible with earlier LCDB versions. Land cover features are described by a polygon boundary, a land cover code, and a land cover name at each nominal time step; summer 1996/97, summer 2001/02, summer 2008/09, summer 2012/13, and summer 2018/19.\n</p>\n<p>\n    The data set was designed to be compatible in theme, scale and accuracy with Land Information New Zealand's 1:50,000 topographic database. LCDB is intended to be used in areas such as state of environmental monitoring, forest and shrubland inventory, biodiversity assessment, trend analysis and infrastructure planning. LCDB5 was released in January 2020 and includes corrections to all time steps 1997/97, 2001/02, 2008/09, 2012/13 and 2018/19.\n</p>"
            }
        ]
    },
    {
        "id": "b39ab2ca-1f4c-44c0-8fd3-f23b1f4c88b6",
        "title": "Wetlands",
        "metadata": [
            {
                "title": "Wetlands",
                "description": "<p>This wetlands dataset has its origins in the Wetlands of National Importance (WONI) project, which was part of the Sustainable Development Programme of Actions for Freshwaters which had the goal of identifying a list of water bodies that would protect a full range of freshwater biodiversity. The pre-human extent of wetlands was produced using soil information from the New Zealand Land Resource Inventory (NZLRI) and a 15m digital elevation model (DEM) to refine soil boundaries. Current wetlands were defined by combining existing databases including LCDB2 (Land Cover Database version 2), NZMS 260 Topomaps, existing surveys from Regional Councils, Queen Elizabeth II (QEII) covenant wetland polygons, DOC surveys (WERI database), and the 15m DEM, to define a single set of wetland polygons and centre points. All this data was checked against a standardised set of Landsat imagery using the Ecosat technology and where necessary new wetland boundaries delineated. Wetlands were classified into 7 groups at the hydro-class level using fuzzy expert rules.</p>"
            }
        ]
    },
    {
        "id": "bf3a5391-76c1-4e78-86e5-4a12e195e499",
        "title": "Sediment Retained (2012)",
        "metadata": [
            {
                "title": "Sediment Retained (2012)",
                "description": "<p><span>This layer depicts estimated sediment/soil retention across New Zealand and was created using the NZeem erosion model. Sediment retained is defined as the difference between soil loss with and without tree cover (sediment loss avoided). Erosion control is defined as the prevention of soil loss by an ecosystem. NZeem has been calibrated from sediment discharges measured in New Zealand rivers (Dymond et al., 2010). This model estimates the long-term mean erosion rate from all sources of erosion, both mass-movement and surficial, and accounts for all sizes of rainfall events. The model was run on the national datasets of rainfall, erosion terrains, and land cover to produce a national 1:50,000 scale map of long-term mean erosion rates. Dymond et al. (2010) assessed the accuracy of the model by comparing predictions of specific sediment discharge (assuming sediment delivery ratio of 1 everywhere) with available measurements and obtained a model efficiency of 0.64.</span></p>\n<p><em>The interpretation in Our Environment based <span>generated using the NZeem erosion model, calibrated from sediment discharges measured in New Zealand rivers (Dymond et al., 2010)</span>&nbsp;and therefore subject to the accuracy of those data is: Sediment Retained.</em></p>"
            }
        ]
    },
    {
        "id": "c6e504cf-2463-419a-bf7d-fed220e119dc",
        "title": "Suitability for Production Forestry",
        "metadata": [
            {
                "title": "Suitability for Production Forestry\n",
                "description": "<p>Classification of land according to suitability for production forestry (based on assessed site index for Pinus radiata). The site index is an estimate (or measurement) of the mean height (in metres) of the 100 tallest 20-year-old trees in a sampled hectare. Pinus radiata was adopted as the species standard because of its ubiquity in New Zealand and not because it is necessarily the most suitable species for the site. Selective and genetic breeding programmes focusing on Pinus radiata have, in recent years, produced clones with growth rates significantly higher than those recorded in the LRIS database. High growth rates have often been achieved at a cost of lower wood density.<br><br>The data in this layer was collected over an extended period. Most of South Island was mapped between 1971 and 1979. In the North Island, Northland was mapped between 1985-1990, Wellington between 1987-1992, Marlborough between 1989-1993 and Gisborne East Coast between 1995-1998. The rest of the North Island was mapped between 1971 and 1979.</p>"
            }
        ]
    },
    {
        "id": "cb8d3240-dcca-4e6f-acaa-e09941cce5e7",
        "title": "General Suitability",
        "metadata": [
            {
                "title": "General Suitability",
                "description": "<p>Classification of land according to general suitability for different land uses. This classification is based on the New Zealand Land Resource Inventory (NZLRI) Land Use Capability (LUC) rating of the ability of each polygon to sustain agricultural production, based on an assessment of the inventory factors: rock type, soil, slope, present type and severity of erosion, and vegetation; along with climate, the effects of past land use, and the potential for erosion.<br><br>The data in this layer was collected over an extended period. Most of South Island was mapped between 1971 and 1979. In the North Island Northland was mapped between 1985-1990, Wellington between 1987-1992, Marlborough between 1989-1993 and Gisborne East Coast between 1995-1998. The rest of the North Island was mapped between 1971 and 1979.</p>"
            }
        ]
    },
    {
        "id": "d8e86d38-9791-4491-ad21-c0e30f05318a",
        "title": "Water Yield (2012)",
        "metadata": [
            {
                "title": "Water Yield (2012)",
                "description": "<p><span><span>This layer represents the net supply of water remaining after evapo-transpiration losses (mm/yr) as an indicator of water- flow regulation. Although this is a simplified view and does not consider low flows or flood flows, it permits national assessment with the use of a nationally applicable water-balance model (similar to the tier 1 approach in Kareiva et al. (2011)). WATYIELD (Fahey et al., 2010) models daily water transfers of rainfall, interception, evapotranspiration, and drainage associated with a soil profile. Input data to the model are daily rainfall and daily potential evapotranspiration (PET). Parameters required for the model included the fraction of intercepted rainfall, vegetation factors for transpiration, and total and readily available water holding capacity of the soil.</span><br></span></p>\n<p><em>The interpretation in Our Environment based on data generated using daily rainfall and daily potential evapotranspiration (PET) and the WATYIELD (Fahey et al., 2010) model, which models daily water transfers of rainfall, interception, evapotranspiration, and drainage associated with a soil profile data and therefore subject to the accuracy of those data is: Water Yield.</em></p>"
            }
        ]
    },
    {
        "id": "e975063a-02fc-47d3-b03f-90e310dd57ec",
        "title": "Erosion (Observed)",
        "metadata": [
            {
                "title": "Observed Erosion Severity (2002)",
                "description": "<p>Present and potential erosion are significant factors for land management and the environmental and economic sustainability of the land. Erosion is classified by type (e.g. sheet, soil slip or gully) and by severity. 'Observed Erosion Severity' type is also classified from 'negligible' to 'extreme'.  Note that because of the varying nature of erosion processes, severity may refer to :- percent area coverage of erosion, size of erosion features in hectares, or in the case of stream bank erosion by length and lateral extent of erosion features.</p>"
            }
        ]
    },
    {
        "id": "ef0ef9d5-9b15-4db2-9fb0-65531dee505f",
        "title": "Wetlands",
        "metadata": [
            {
                "title": "Wetlands",
                "description": "<p>This wetlands dataset has its origins in the Wetlands of National Importance (WONI) project, which was part of the Sustainable Development Programme of Actions for Freshwaters which had the goal of identifying a list of water bodies that would protect a full range of freshwater biodiversity.<br>The pre-human extent of wetlands was produced using soil information from the New Zealand Land Resource Inventory (NZLRI) and a 15m digital elevation model (DEM) to refine soil boundaries. Current wetlands were defined by combining existing databases including LCDB2 (Land Cover Database version 2), NZMS 260 Topomaps, existing surveys from Regional Councils, Queen Elizabeth II (QEII) covenant wetland polygons, DOC surveys (WERI database), and the 15m DEM, to define a single set of wetland polygons and centre points. All this data was checked against a standardised set of Landsat imagery using the Ecosat technology and where necessary new wetland boundaries delineated.<br><br>Wetlands were classified into 7 groups at the hydro-class level using fuzzy expert rules.</p>"
            }
        ]
    },
    {
        "id": "f3d8cfe7-ab36-480d-a149-3893c326e8e4",
        "title": "Most intensive, physically-sustainable land use possible\n",
        "metadata": [
            {
                "title": "Most intensive, physically-sustainable land use possible\n",
                "description": "<div>Classification of land according to its suitability to the most intensive, physically-sustainable land use possible. This classification is based on the New Zealand Land Resource Inventory (NZLRI) Land Use Capability (LUC) rating.<br><br>The data in this layer was collected over an extended period. Most of South Island was mapped between 1971 and 1979. In the North Island, Northland was mapped between 1985-1990, Wellington between 1987-1992, Marlborough between 1989-1993 and Gisborne East Coast between 1995-1998. The rest of the North Island was mapped between 1971 and 1979.</div>"
            }
        ]
    },
    {
        "id": "fca31715-13b9-4f82-a9ae-118977f13ccd",
        "title": "Basic Ecosystems (2002-2008)",
        "metadata": [
            {
                "title": "Basic Ecosystems (2002-2008)",
                "description": "<p>This layer was derived from three existing data layers: the Land Cover Database 2 (LCDB2) (MfE 2002); the Land Use Map (LUM) from the Land Use Carbon Analysis System (MfE 2008; Dymond et al. 2012); and EcoSat Forests (Shepherd et al. 2002). Indigenous forest classes from EcoSat Forests were combined with classes from LCDB2 to form basic ecosystems classes. Where indigenous forest was mapped by LCDB2, the type of forest was determined from the EcoSat Forests layer. The eight forest types of EcoSat Forests were reduced to three basic types: beech forest; podocarp-broadleaved forest; and mixed beech and podocarp-broadleaved forest. To produce a recent 2008 layer the LUM was used to update indigenous and exotic forest changes since 2002. The mapping was performed using 15 m pixels, which is equivalent to a mapping scale of approximately 1:50,000.</p>\n<p><em>The interpretation in Our Environment based on LCDB2, LUM and ECOSAT data and therefore subject to the accuracy of those data is: Basic Ecosystems.</em></p>"
            }
        ]
    },
    ...suitabilityMetadata.metadataCollections
];

const sectionViewIds = [
    {
        "id": "007a6c71-5e0a-4ff3-8b91-f81ffb951ee5",
        "views": [
            {
                "id": "5e5964cd-a8ea-4244-9d03-9857b56e310b",
                "title": "table"
            },
            {
                "id": "6fd3beda-c9f9-43c3-bed8-db3244c93ecf",
                "title": "bar chart"
            },
            {
                "id": "8dbba904-13a1-4311-9bcd-4ea0a9105a87",
                "title": "bubble"
            },
            {
                "id": "95d4d947-2eed-4a12-9c98-66a14139fa80",
                "title": "tree map"
            }
        ]
    },
    {
        "id": "125c0035-3c12-4a27-8780-92afc2c050ef",
        "views": [
            {
                "id": "02baa318-e8be-470b-a042-d03397f85ba3",
                "title": "bar chart"
            },
            {
                "id": "1315a7cc-0f06-491f-9e84-de09ae547646",
                "title": "bubble"
            },
            {
                "id": "4897613e-7c7c-4db1-a317-5a8bc75b2b82",
                "title": "tree map"
            },
            {
                "id": "f9c7ac33-e210-4b54-b914-afced9437013",
                "title": "table"
            }
        ]
    },
    {
        "id": "14667185-5237-4615-8704-6e72bc253f71",
        "views": [
            {
                "id": "74aa8cf5-4dad-410e-b3f4-a8ffcd561489",
                "title": "point attributes"
            }
        ]
    },
    {
        "id": "1e7013a8-5a0b-4a71-a439-211fa00143f3",
        "views": [
            {
                "id": "04984670-340e-45bf-9709-f0e21741dbe0",
                "title": "tree map"
            },
            {
                "id": "86e03b0e-8548-4c85-871c-cc6645bb5baf",
                "title": "table"
            },
            {
                "id": "98f937be-4416-4c5b-bb5b-42a6b6e6f84f",
                "title": "bar chart"
            },
            {
                "id": "f0b8df50-9289-4007-a1fc-35919798cb47",
                "title": "bubble"
            }
        ]
    },
    {
        "id": "1fe167fc-d100-4332-a734-2db6843530ad",
        "views": [
            {
                "id": "2940ea42-1255-462c-bbe0-e2731c85d7f6",
                "title": "table"
            },
            {
                "id": "46aaf7a1-2b97-4671-9c7d-9b27a54eb3f5",
                "title": "bubble"
            },
            {
                "id": "5dc06cb7-7f1a-4a72-9a09-f1602ba321a5",
                "title": "bar chart"
            },
            {
                "id": "b5beb092-a6f8-43c9-9ca8-7e6a069b0e71",
                "title": "tree map"
            }
        ]
    },
    {
        "id": "2459d364-10dd-4142-94d8-263682b6cea9",
        "views": [
            {
                "id": "01ad41e3-93db-450e-916a-c21984df9c51",
                "title": "table"
            },
            {
                "id": "aec3bc23-09b1-43ff-a212-52804edea3b4",
                "title": "bubble"
            },
            {
                "id": "da41fcd9-2ee7-4b8f-9b03-c6e5aa809cae",
                "title": "bar chart"
            },
            {
                "id": "de97c24b-eb98-4866-a9b1-439b110b2bb0",
                "title": "tree map"
            }
        ]
    },
    {
        "id": "298239c1-c713-45eb-a872-90af302d490a",
        "views": [
            {
                "id": "149ff151-78bc-40a2-bdc1-1bd5ab553397",
                "title": "table"
            },
            {
                "id": "709b2503-2922-4c99-b307-2237ec654339",
                "title": "bubble"
            },
            {
                "id": "8f8b9d19-26e3-47c2-bb1d-cca1ddc1ec3b",
                "title": "tree map"
            },
            {
                "id": "c5fe8d35-bc02-4ab9-beb4-77c04c845783",
                "title": "bar chart"
            }
        ]
    },
    {
        "id": "348eb883-f847-4ada-aa87-e9ce0b248cda",
        "views": [
            {
                "id": "ff372a45-fae8-4ad4-bc30-e6bc4e3d1573",
                "title": "point attributes"
            }
        ]
    },
    {
        "id": "358ad3c9-e4c4-4d39-9d0e-4d67b563d889",
        "views": [
            {
                "id": "0805783f-4f2c-4a79-a1f8-6b2afd37afcf",
                "title": "bubble"
            },
            {
                "id": "1e0e9a68-aa23-42e5-add4-7c55af2f1002",
                "title": "bar chart"
            },
            {
                "id": "78f5700b-dab0-47b8-8a6f-ea5b47881831",
                "title": "tree map"
            },
            {
                "id": "b0ebae96-8c9d-45cc-adf1-c878f2800087",
                "title": "table"
            }
        ]
    },
    {
        "id": "360f5048-f1a9-4ecf-8c82-39c79860bceb",
        "views": [
            {
                "id": "fd02aaef-3276-4a25-ab4e-276e053949d5",
                "title": "loss/gain chart horizontal"
            }
        ]
    },
    {
        "id": "38f9eace-acba-4b56-ba83-4b46345119bd",
        "views": [
            {
                "id": "4a8697db-84ac-4d05-a787-ffa86ee732ca",
                "title": "bar chart"
            },
            {
                "id": "4bebba33-d363-497f-b36e-dc219060ec86",
                "title": "table"
            },
            {
                "id": "677bfea7-c2a6-446d-a283-7380fe828325",
                "title": "tree map"
            },
            {
                "id": "ec058719-14ce-4bba-9344-8f3b9c41cee1",
                "title": "bubble"
            }
        ]
    },
    {
        "id": "39376b0a-efef-42c4-aa54-9bb795d82616",
        "views": [
            {
                "id": "7a8e922b-4242-44b6-9c80-7e89b8c41f12",
                "title": "point attributes"
            }
        ]
    },
    {
        "id": "4546ad02-7e52-4530-a959-bd53dce90e30",
        "views": [
            {
                "id": "910a66fa-593f-4ebf-a704-3a5e4dc9aa48",
                "title": "point attributes"
            }
        ]
    },
    {
        "id": "6085122f-1468-4793-85fa-600bf5fc0e15",
        "views": [
            {
                "id": "b2f9ca77-c31d-4cd3-abb7-b160573b572b",
                "title": "loss/gain chart"
            }
        ]
    },
    {
        "id": "635dad3c-a3dc-4d87-ba92-5a1b7831a14b",
        "views": [
            {
                "id": "047679f9-186d-4025-b2aa-b97a29195ae0",
                "title": "tree map"
            },
            {
                "id": "2142f60b-f65b-4e52-90c3-f49f6c1b5197",
                "title": "table"
            },
            {
                "id": "6d93d887-457e-486b-b6e4-a0b60d4e3d3f",
                "title": "bar chart"
            },
            {
                "id": "ccd1371f-7dab-4a84-8942-e0947399f094",
                "title": "bubble"
            }
        ]
    },
    {
        "id": "6426cba4-9c13-4855-ad4b-8bf728f59000",
        "views": [
            {
                "id": "e84b166a-8870-4af4-bff7-915e71f13a80",
                "title": "point attributes"
            }
        ]
    },
    {
        "id": "71991690-7327-43fa-8935-67004d04d1f3",
        "views": [
            {
                "id": "50b25be4-b7dc-4b3e-a9be-a0130bbdfcf2",
                "title": "bubble"
            },
            {
                "id": "8eec7b81-1cf7-46fd-9c48-b9b244720d16",
                "title": "tree map"
            },
            {
                "id": "beaec015-395e-43ba-bfde-f004d04ac36e",
                "title": "bar chart"
            },
            {
                "id": "beafed98-81d1-45ec-b165-e31527ab732a",
                "title": "table"
            }
        ]
    },
    {
        "id": "719cb2ce-5e29-4953-ab6c-a223feeca5a1",
        "views": [
            {
                "id": "7e604002-c3ff-4491-bd36-c5bab59b8aea",
                "title": "point attributes"
            }
        ]
    },
    {
        "id": "76956174-b61a-4879-8243-b6f31a525bd5",
        "views": [
            {
                "id": "32758105-ed00-45fa-8c61-d1c417a5a314",
                "title": "point attributes"
            }
        ]
    },
    {
        "id": "7fac687b-72b4-4e2f-b565-ffcd8eb25140",
        "views": [
            {
                "id": "b1d63fa6-a434-42d0-aee2-a4d5cd931028",
                "title": "point attributes"
            }
        ]
    },
    {
        "id": "80b45c7c-50ae-4dac-8703-fc4ea2ffed9e",
        "views": [
            {
                "id": "1d7d8bc9-ef65-482a-a7d0-e32820fcbe2d",
                "title": "table"
            },
            {
                "id": "401f42de-f83a-443d-80cb-9e7e3353b3ad",
                "title": "bar chart"
            },
            {
                "id": "bdacb4a3-ee2a-422b-8204-b5115e02050b",
                "title": "bubble"
            },
            {
                "id": "c18542e3-dd49-4ce5-bf77-7b5a52cd941f",
                "title": "tree map"
            }
        ]
    },
    {
        "id": "86db4e0e-610c-4794-b4cb-2802a2b3e001",
        "views": [
            {
                "id": "4338bfb2-102f-4913-b75e-486a91d6d52c",
                "title": "table"
            },
            {
                "id": "4a5542d2-780c-4649-9b23-3586875947f7",
                "title": "bar chart"
            },
            {
                "id": "9eec2e81-e368-46ce-a0e8-7ac44dd325d2",
                "title": "tree map"
            },
            {
                "id": "a307f56c-f28a-4064-b58c-0d9e851a54be",
                "title": "bubble"
            }
        ]
    },
    {
        "id": "92d7f534-a972-4414-a3a3-f7694a79d57c",
        "views": [
            {
                "id": "72dd99c0-1bbf-4b34-abd2-72be014c9c36",
                "title": "point attributes"
            }
        ]
    },
    {
        "id": "93bf5b92-40d8-4085-a357-04363505a61e",
        "views": [
            {
                "id": "0efa3d09-78fd-468b-889e-72afd48814bc",
                "title": "bubble"
            },
            {
                "id": "16df933a-ad0b-48d8-8378-0876f618ee15",
                "title": "bar chart"
            },
            {
                "id": "218e1359-ede7-454d-be62-9f1c8e8eb571",
                "title": "tree map"
            },
            {
                "id": "d14bc3f7-f217-4f7e-b661-86cadfb0027e",
                "title": "table"
            }
        ]
    },
    {
        "id": "951cf965-72c4-4ce5-a4f4-cb87907e2318",
        "views": [
            {
                "id": "57863f10-6622-4de4-9413-209c5960e27e",
                "title": "point attributes"
            }
        ]
    },
    {
        "id": "9fa96f54-d81b-4b2c-9a92-fd6f18c55654",
        "views": [
            {
                "id": "3593439b-b214-4406-a081-299bd1cab2e4",
                "title": "point report header"
            }
        ]
    },
    {
        "id": "a144c0c3-235b-413f-a75d-09b6218ee37e",
        "views": [
            {
                "id": "757b7854-a7fc-49b5-a2e5-b8eaba27c0aa",
                "title": "point attributes"
            }
        ]
    },
    {
        "id": "a35a15b9-c576-45fe-a5f5-41200300ced1",
        "views": [
            {
                "id": "6f502cfc-0548-4916-b9a1-c39d6b4c067a",
                "title": "point attributes"
            }
        ]
    },
    {
        "id": "a68eaa10-fc92-4fda-9e9c-8ac59568487c",
        "views": [
            {
                "id": "40b870a5-becf-4b8d-b702-006f14ad86a5",
                "title": "bar chart"
            },
            {
                "id": "869bb173-0844-4533-be0b-4a999ec102a6",
                "title": "tree map"
            },
            {
                "id": "d52085c7-2b71-4204-b743-1330e0c8df48",
                "title": "table"
            },
            {
                "id": "dc002040-6ccc-4187-8d1f-8f8faeca2dfa",
                "title": "bubble"
            }
        ]
    },
    {
        "id": "ad002cfb-881e-4381-b7c3-710aa5a3639b",
        "views": [
            {
                "id": "27f20272-a2ae-4859-a917-b2932c4c4242",
                "title": "table"
            },
            {
                "id": "55370126-8d66-460f-8ec4-26d928c4f3a2",
                "title": "bar chart"
            },
            {
                "id": "800a339d-72de-4a62-81d0-56d03ad21fe3",
                "title": "bubble"
            },
            {
                "id": "ca6b6a96-feb9-4fd1-963a-71e014d3f036",
                "title": "tree map"
            }
        ]
    },
    {
        "id": "ae4f98db-389d-4065-a18a-060459c624f3",
        "views": [
            {
                "id": "463e4bab-582c-4032-83d9-58bc791f3bc6",
                "title": "point attributes"
            }
        ]
    },
    {
        "id": "b359ddbb-71ec-440d-b4ad-5b4e5f08cffc",
        "views": [
            {
                "id": "6f9802f4-e999-4349-8986-6e7aaaaa0e10",
                "title": "point attributes"
            }
        ]
    },
    {
        "id": "b9480c52-43d6-430f-bbe6-034583cd6d0e",
        "views": [
            {
                "id": "19117137-29cb-4a26-8a13-b943482779da",
                "title": "bubble"
            },
            {
                "id": "293f80a8-dab9-40c3-9402-b9cd63b7c6b2",
                "title": "bar chart"
            },
            {
                "id": "29817aac-bf0e-4214-9f23-433af271176c",
                "title": "tree map"
            },
            {
                "id": "d21937cd-a09f-43ff-bea4-5e56ba0c78ee",
                "title": "table"
            }
        ]
    },
    {
        "id": "bffd2b62-01a6-45dc-a541-743dca906675",
        "views": [
            {
                "id": "0ff3c6f7-439e-47e0-90ac-86a5e947fa77",
                "title": "point attributes"
            }
        ]
    },
    {
        "id": "c67a8cee-eba5-4744-82b1-e2bfc60d507f",
        "views": [
            {
                "id": "52f8ba3a-8f37-4d05-aadd-cda32188b27d",
                "title": "bar chart"
            },
            {
                "id": "7cd49ee5-9a50-40c1-91a1-2ea539c67ad6",
                "title": "bubble"
            },
            {
                "id": "99ba183c-b236-49c2-8f12-69e711b24aeb",
                "title": "tree map"
            },
            {
                "id": "a33ae9f8-0c26-43d6-98b0-42391b8b484c",
                "title": "table"
            }
        ]
    },
    {
        "id": "c9132be1-4a26-4998-b72b-197f45bd52b9",
        "views": [
            {
                "id": "b57340ad-a0e5-4fa3-8611-515170065ef3",
                "title": "point attributes"
            }
        ]
    },
    {
        "id": "cea03eef-aa09-43c7-8be5-678a02036a89",
        "views": [
            {
                "id": "81401d11-7f6d-46a4-8d7c-3dc4f0915d01",
                "title": "polygon attributes"
            }
        ]
    },
    {
        "id": "d1b59a0a-1393-4000-93a0-925f6781e489",
        "views": [
            {
                "id": "10a3a39f-26ec-4131-80c5-708fbe4353ab",
                "title": "bar chart"
            },
            {
                "id": "625c1628-075a-433a-82db-6571305bfa8c",
                "title": "bubble"
            },
            {
                "id": "79cf7ee2-e823-4797-8b7a-c824f064d6b6",
                "title": "table"
            },
            {
                "id": "965317e8-1578-4165-b03d-a49e8e740b08",
                "title": "tree map"
            }
        ]
    },
    {
        "id": "d4b5fcc3-05b7-40f8-97f2-b31de336b7db",
        "views": [
            {
                "id": "46e9097a-f48e-4ca3-bbc2-084c3662b32d",
                "title": "table"
            },
            {
                "id": "4ea84c9c-f935-4e0b-9b76-4df8d90b0d15",
                "title": "bubble"
            },
            {
                "id": "873114f4-a1fe-4a77-b743-d684a5ff0935",
                "title": "tree map"
            },
            {
                "id": "f8c9e34d-ae7c-4c0c-ba54-d5e8ddb4e0d5",
                "title": "bar chart"
            }
        ]
    },
    {
        "id": "d90fdd6e-b5d8-4522-aefa-3fd3e4da994a",
        "views": [
            {
                "id": "91d2b840-9757-4075-99c1-01d4ed71d8c3",
                "title": "point attributes"
            }
        ]
    },
    {
        "id": "dce0f7da-59b8-418b-9c73-6ffc7023c90e",
        "views": [
            {
                "id": "30f321df-456e-43e0-8aa4-8a93eff0fff3",
                "title": "point attributes"
            }
        ]
    },
    {
        "id": "e29dc242-4b24-42f4-97c6-a0711bb32aa9",
        "views": [
            {
                "id": "c543841b-bf2a-40e7-b495-b22a546b8e99",
                "title": "point attributes"
            }
        ]
    },
    {
        "id": "ed93ac67-9bba-4070-b9a7-7ed329fe5eba",
        "views": [
            {
                "id": "473009d2-6471-4107-a720-bc39e39e8c97",
                "title": "table"
            },
            {
                "id": "6d265bed-a537-440c-b15b-c64799183ca7",
                "title": "tree map"
            },
            {
                "id": "b41c0a79-895a-494b-95c9-aee66962785e",
                "title": "bubble"
            },
            {
                "id": "fa36babc-51d3-4ec4-917d-537bc0889722",
                "title": "bar chart"
            }
        ]
    },
    {
        "id": "f37f2412-cf46-4f63-822a-72e9f4556adc",
        "views": [
            {
                "id": "483a8a90-f670-4495-a03c-1c7bf5d93419",
                "title": "point attributes"
            }
        ]
    },
    {
        "id": "f92fdc8f-295a-4ae1-abfb-f4eba918cf28",
        "views": [
            {
                "id": "0b7e8b1d-67b8-4dbb-99c6-ec8815d23e88",
                "title": "bubble"
            },
            {
                "id": "765ec3c3-f825-4b63-8faf-954f85c818f9",
                "title": "tree map"
            },
            {
                "id": "a12a50e5-65f4-4199-94c3-aeaa59e4cd2a",
                "title": "bar chart"
            },
            {
                "id": "eb9e9dc9-fe98-4566-8145-8db8d679f9d0",
                "title": "table"
            }
        ]
    },
    {
        "id": "fb977e77-f856-4a21-8c23-c4313b5680e9",
        "views": [
            {
                "id": "f78a631a-9931-44e5-8c47-bfa9e80550f5",
                "title": "point attributes"
            }
        ]
    },
    {
        "id": "f6cfa7a5-5a1d-49eb-88a2-621d432b5cb3",
        "views": [
            {
                "id": "f93a5466-83a6-4c4a-8094-3c8e802ec878",
                "title": "bubble"
            },
            {
                "id": "cf02220d-af54-49e7-91aa-38173d6e33d3",
                "title": "tree map"
            },
            {
                "id": "e256801f-7630-4b94-97b9-7be52909e2e1",
                "title": "bar chart"
            },
            {
                "id": "98d0acdf-7023-41f1-af51-fce269236b98",
                "title": "table"
            }
        ]
    },
    {
        "id": "cf06e2d4-01d3-495d-8b92-56e8dc744a20",
        "views": [
            {
                "id": "218e8139-6bfc-47e8-ace0-d94255d6abed",
                "title": "point attributes"
            }
        ]
    },
    {
        "id": "f8de6783-4b7c-491a-873c-30a5eb208ff4",
        "views": [
            {
                "id": "7785f98e-f03c-4230-b296-467abecaa3f3",
                "title": "bubble"
            },
            {
                "id": "53904a80-b171-4322-abb0-ae032d6e5e54",
                "title": "tree map"
            },
            {
                "id": "205f09af-9a3d-425d-8730-c97fb1fff16e",
                "title": "bar chart"
            },
            {
                "id": "f01998c0-f35d-43fa-b5f7-00f2968d175e",
                "title": "table"
            }
        ]
    },
    {
        "id": "73c4ce4d-f5c1-4ffb-82fa-83b29adccbaf",
        "views": [
            {
                "id": "8e2055a3-ba02-4eb5-981f-e2f386faa8fc",
                "title": "bubble"
            },
            {
                "id": "f47ab24e-889a-474d-85b4-b99c403819c2",
                "title": "tree map"
            },
            {
                "id": "ae8f195c-d82e-41cf-b6b3-cd83c45791cf",
                "title": "bar chart"
            },
            {
                "id": "c031a868-f80f-4298-9b57-954bb5b26cb4",
                "title": "table"
            }
        ]
    },
    {
        "id": "b5a0ca87-53c9-41ac-a6ae-665af5da3e98",
        "views": [
            {
                "id": "796f45dd-c57e-462f-a617-782c0de2c002",
                "title": "bubble"
            },
            {
                "id": "c972ecd9-0869-4012-a1af-c00bedda2186",
                "title": "tree map"
            },
            {
                "id": "408c0056-1722-4504-82fb-2b61207e2da0",
                "title": "bar chart"
            },
            {
                "id": "246d6a90-e080-4325-8116-4048942d775d",
                "title": "table"
            }
        ]
    },
    {
        "id": "e7ade83f-281b-42a2-9667-97597f777ce7",
        "views": [
            {
                "id": "3adb4b84-843a-4f42-a90f-c3587e0ebeba",
                "title": "bubble"
            },
            {
                "id": "eccd51c8-9887-4d30-8d71-edac2d4d8c89",
                "title": "tree map"
            },
            {
                "id": "26ea2369-bad0-4120-9780-88b13d645fb0",
                "title": "bar chart"
            },
            {
                "id": "2a2d4ef6-2040-4d69-83d1-0ff530b6dfdf",
                "title": "table"
            }
        ]
    },
    {
        "id": "102324e1-acbc-4a8b-ac05-5f767a3a40fe",
        "views": [
            {
                "id": "f77be929-d6d7-42de-8833-84fcf3383f1f",
                "title": "bubble"
            },
            {
                "id": "37edd445-bf55-4c80-ac10-ac6fb9154fe8",
                "title": "tree map"
            },
            {
                "id": "907ad5a0-f040-42d1-ae7e-21de947d5dde",
                "title": "bar chart"
            },
            {
                "id": "5344fdf0-431d-40b0-a269-80a5b1764623",
                "title": "table"
            }
        ]
    },
    {
        "id": "7b499ed2-a821-4e6e-b642-32f03210ec9e",
        "views": [
            {
                "id": "36826545-ecd1-4a6d-b073-35661343983c",
                "title": "bubble"
            },
            {
                "id": "3747685e-d0f9-40ac-a86c-89cac97862e1",
                "title": "tree map"
            },
            {
                "id": "00b4c074-b49d-4a9c-af10-fd15c0bd495b",
                "title": "bar chart"
            },
            {
                "id": "6753e082-1827-435a-8f67-ea568ff3211c",
                "title": "table"
            }
        ]
    },
    {
        "id": "33d328da-5c92-4535-b37b-56a9058dedfb",
        "views": [
            {
                "id": "1abfeb28-f750-4712-abe3-4d156d7250a7",
                "title": "bubble"
            },
            {
                "id": "3bed5d65-3883-47e1-a795-d01e44451fae",
                "title": "tree map"
            },
            {
                "id": "ada3c6b1-9e5d-46ab-ac6f-e227d87bd19b",
                "title": "bar chart"
            },
            {
                "id": "cd97dc70-36bb-4c93-a09b-9668b4b06c6a",
                "title": "table"
            }
        ]
    },
    {
        "id": "c4e3d504-b067-452e-bb35-ef3c993cfc6e",
        "views": [
            {
                "id": "6a03d007-ca60-41d3-9cd5-3440769f0a8f",
                "title": "bubble"
            },
            {
                "id": "e3e0ae30-b449-4683-810c-3ac4a7e101a7",
                "title": "tree map"
            },
            {
                "id": "9d7adf2c-3dce-49dd-8dd9-9ece0f8598e7",
                "title": "bar chart"
            },
            {
                "id": "53682afd-adff-4fde-acf0-4bd92f472cd9",
                "title": "table"
            }
        ]
    },
    {
        "id": "d5060008-b879-4403-999b-e155da44d35c",
        "views": [
            {
                "id": "75979dc8-f5fa-4ae1-a8f5-3ab041a7ca78",
                "title": "bubble"
            },
            {
                "id": "420705a2-89f2-4dcb-84a4-25f82208ab74",
                "title": "tree map"
            },
            {
                "id": "53337eb3-9c8c-4890-8f67-d2eebf3196ef",
                "title": "bar chart"
            },
            {
                "id": "060ab66b-1829-475f-ab1a-0acc3b32b1f0",
                "title": "table"
            }
        ]
    },
    {
        "id": "5f5e2b0c-19fa-413a-9505-08a45e849212",
        "views": [
            {
                "id": "f07423a9-2a6f-45fe-b725-7f75beb153c6",
                "title": "bubble"
            },
            {
                "id": "2d4fd61f-f2cb-49ba-afce-f9f5363dae7f",
                "title": "tree map"
            },
            {
                "id": "1f50b869-7656-4405-8000-dc16e70d0c3c",
                "title": "bar chart"
            },
            {
                "id": "65aa28c2-9f06-47b4-a320-2ad5be194122",
                "title": "table"
            }
        ]
    },
    {
        "id": "cd5df86d-6322-40a0-a96b-a762d3e49d13",
        "views": [
            {
                "id": "d6ebccfd-95a8-43a9-9de1-c9b66be3b8ae",
                "title": "bubble"
            },
            {
                "id": "1bcd56fc-e874-45e1-8528-9eb26f7e177c",
                "title": "tree map"
            },
            {
                "id": "594058a4-65ab-45ee-9261-3d736a67333c",
                "title": "bar chart"
            },
            {
                "id": "d29fd72a-2abb-427d-9260-45039cdfd516",
                "title": "table"
            }
        ]
    },
    {
        "id": "80cf8e7a-765b-4efc-b121-f038b1250428",
        "views": [
            {
                "id": "d146ddff-ffcf-433e-b5f8-ed4908ebd537",
                "title": "bubble"
            },
            {
                "id": "3fec6bac-5bd2-4583-8e03-30b5e9718de2",
                "title": "tree map"
            },
            {
                "id": "04486c83-945d-4709-a4c2-e324eacb3f44",
                "title": "bar chart"
            },
            {
                "id": "f83323d7-caa2-4da7-8a46-e901214a6d44",
                "title": "table"
            }
        ]
    },
    {
        "id": "0865be58-eb26-4726-9aa3-e4b4bea2aee0",
        "views": [
            {
                "id": "c40e9f1c-7a2d-4cf9-844e-e4418e3625d7",
                "title": "bubble"
            },
            {
                "id": "0661020a-1745-449b-ad50-7f00b83cf9fb",
                "title": "tree map"
            },
            {
                "id": "be81e623-cf88-401f-b209-65640ea54d88",
                "title": "bar chart"
            },
            {
                "id": "bc3ba05e-c2c7-43c0-b576-e9c5c95e8fbd",
                "title": "table"
            }
        ]
    },
    {
        "id": "5a7fa7d1-fcc8-4530-b519-c3b281ccf0bd",
        "views": [
            {
                "id": "2a1c061d-f71b-48a9-85dd-8a1971a51b68",
                "title": "bubble"
            },
            {
                "id": "d4dfbc8a-9311-40a6-8a69-19500710a3b4",
                "title": "tree map"
            },
            {
                "id": "5d67f624-46ec-46ee-aaf9-74290d7fc5b6",
                "title": "bar chart"
            },
            {
                "id": "51f9d9bf-c80c-402e-9f88-81330c5fdcf0",
                "title": "table"
            }
        ]
    },
    {
        "id": "6cde440b-ddbf-4610-817f-9390d3e15896",
        "views": [
            {
                "id": "a40a78f5-65cb-4bf3-a66f-72f65e492e50",
                "title": "bubble"
            },
            {
                "id": "491d1b1b-20e0-4798-92e8-76c50abe3234",
                "title": "tree map"
            },
            {
                "id": "222a1303-1791-480a-9fa2-69347d67e0bc",
                "title": "bar chart"
            },
            {
                "id": "46f636bd-c710-44de-8161-a01fabadce9c",
                "title": "table"
            }
        ]
    },
    {
        "id": "d57d4306-930e-463e-a8d4-7197f9abdf5e",
        "views": [
            {
                "id": "f7993387-7d14-47e7-b92b-756beb2d32b1",
                "title": "bubble"
            },
            {
                "id": "83872cc7-5607-40f7-a130-e99bbe346111",
                "title": "tree map"
            },
            {
                "id": "4c7b061a-0130-4d04-b7d4-9e908c788bf5",
                "title": "bar chart"
            },
            {
                "id": "2ea4e02b-a570-4a68-85b8-9a25cc25885a",
                "title": "table"
            }
        ]
    },
    {
        "id": "daa2ec09-4a19-45d5-bb64-2f168e4efc83",
        "views": [
            {
                "id": "8f92cab9-df3d-40f7-bdec-5a4ec0a3b405",
                "title": "bubble"
            },
            {
                "id": "14302b72-28c9-4274-b2d2-03a1d84f1520",
                "title": "tree map"
            },
            {
                "id": "df7396ac-4dfc-4a84-bdb0-6e4c110988d6",
                "title": "bar chart"
            },
            {
                "id": "d33a2985-c389-4afc-a73b-8ec4aad66841",
                "title": "table"
            }
        ]
    },
    {
        "id": "9184c5c2-7b34-468d-876d-abf65b90b51b",
        "views": [
            {
                "id": "778b6076-2e35-420a-becc-364cb7aeb41f",
                "title": "bubble"
            },
            {
                "id": "925c47af-1c43-4efc-b9f4-7945034c1624",
                "title": "tree map"
            },
            {
                "id": "21b20768-1a22-47f4-b401-0f11de199269",
                "title": "bar chart"
            },
            {
                "id": "e83c86b9-3a02-47e6-a454-af36fe89264e",
                "title": "table"
            }
        ]
    },
    {
        "id": "d339eb5a-fa0b-41df-a479-00bb2fd6d6b0",
        "views": [
            {
                "id": "f4173334-55a9-4921-ac60-739db239c642",
                "title": "bubble"
            },
            {
                "id": "81e7fdb2-7821-437a-b602-49f65841ae44",
                "title": "tree map"
            },
            {
                "id": "9d06d05f-09ea-4265-978b-3431d15436e7",
                "title": "bar chart"
            },
            {
                "id": "f834a6c2-83d4-43ab-a2c0-b8b9137ee290",
                "title": "table"
            }
        ]
    },
    {
        "id": "fa636597-a427-42c3-a8ce-34b891e9a78f",
        "views": [
            {
                "id": "774a1a9f-32df-4495-b9b7-7f0cd94fc2fe",
                "title": "bubble"
            },
            {
                "id": "32eca83c-0d97-4503-9aac-77d79fb2e3e1",
                "title": "tree map"
            },
            {
                "id": "17050eca-af68-4ca2-a4df-f08fab03885b",
                "title": "bar chart"
            },
            {
                "id": "0b19bbd0-8da5-4669-8bf3-2063d3153b8e",
                "title": "table"
            }
        ]
    },
    {
        "id": "645913fe-67a4-4bfe-9985-92d66205ef0a",
        "views": [
            {
                "id": "b546fc3a-deea-4c1f-be90-03c08cab0c79",
                "title": "bubble"
            },
            {
                "id": "ad6c11e4-2f85-414d-8b16-20624a337ed1",
                "title": "tree map"
            },
            {
                "id": "016e8204-c348-4d48-b8ec-2a54634511ae",
                "title": "bar chart"
            },
            {
                "id": "19083595-3907-424a-b298-82f57611eb71",
                "title": "table"
            }
        ]
    },
    {
        "id": "71a374fd-3e32-48fc-b36d-ee86710068c2",
        "views": [
            {
                "id": "6415f60e-8492-416b-b8c7-fd2133d1129e",
                "title": "bubble"
            },
            {
                "id": "493d5363-e29a-47fb-b3bd-acd10043fdf2",
                "title": "tree map"
            },
            {
                "id": "b86fc481-a1b6-4c50-9ce0-35463ca8dde5",
                "title": "bar chart"
            },
            {
                "id": "82c9d8e3-b675-4193-8574-0604b31b87c4",
                "title": "table"
            }
        ]
    },
    {
        "id": "2de7c909-1ab1-4eb8-95ec-40b3dd317ea4",
        "views": [
            {
                "id": "b67a3222-8c1c-4f3b-a74f-fdc59879e949",
                "title": "bubble"
            },
            {
                "id": "8415383f-2166-4d4b-81db-bb48e2900d70",
                "title": "tree map"
            },
            {
                "id": "0d455eb3-3458-4b68-aa16-0fe0aa14b453",
                "title": "bar chart"
            },
            {
                "id": "3c158c24-8028-4aa4-8095-3480a5785019",
                "title": "table"
            }
        ]
    },
    {
        "id": "0736a578-0da6-48c3-81ba-342014e33396",
        "views": [
            {
                "id": "3b8863e8-db1a-4d72-8e9f-da018022d223",
                "title": "bubble"
            },
            {
                "id": "e1929b61-b743-497c-8a18-f68d6ebd1abf",
                "title": "tree map"
            },
            {
                "id": "0211e174-e3e4-4728-a978-8b6205b1805e",
                "title": "bar chart"
            },
            {
                "id": "c170c723-df8c-4fc9-83bd-5243ba793a97",
                "title": "table"
            }
        ]
    },
    {
        "id": "5342ec83-213a-4763-a40f-a7d3fafacb12",
        "views": [
            {
                "id": "11beb044-69be-41d8-bf0c-9c641ed41899",
                "title": "bubble"
            },
            {
                "id": "8220495b-c2d2-4a01-985e-1fd478a9fa63",
                "title": "tree map"
            },
            {
                "id": "427aa10f-a693-4ac1-8f5f-364793138d2f",
                "title": "bar chart"
            },
            {
                "id": "c9a1560d-e4ce-4457-8a68-b1a010f0c4a5",
                "title": "table"
            }
        ]
    },
    {
        "id": "be1fb6ea-c062-4d1c-94ba-d3dada322152",
        "views": [
            {
                "id": "2b3e799f-ac18-4e2e-9023-2255aa242523",
                "title": "bubble"
            },
            {
                "id": "31397b17-ac94-4f29-91cd-72db38473e68",
                "title": "tree map"
            },
            {
                "id": "90e57809-2046-4907-94a6-c3c5976a3dbc",
                "title": "bar chart"
            },
            {
                "id": "c0edfe89-dfd6-4266-aa21-6116bd6b6d53",
                "title": "table"
            }
        ]
    },
    {
        "id": "191d212e-216d-4498-a185-b9326ca8c327",
        "views": [
            {
                "id": "c7b2be18-76d6-46ab-8e80-c0050dc1608f",
                "title": "bubble"
            },
            {
                "id": "7fa68427-0ef5-476d-abf8-41c5b22aa0b6",
                "title": "tree map"
            },
            {
                "id": "71c871fb-e59a-47fc-b0c0-cd4fc485b0b8",
                "title": "bar chart"
            },
            {
                "id": "10997f57-c091-4a4b-9012-740811e3e403",
                "title": "table"
            }
        ]
    },
    {
        "id": "253da64c-e433-4397-acce-7b3853372944",
        "views": [
            {
                "id": "6e0f81f9-a831-4d72-ada2-3ed8bbad73a3",
                "title": "bubble"
            },
            {
                "id": "ed3773dd-3ba3-408d-933b-58d1cd18f91c",
                "title": "tree map"
            },
            {
                "id": "70af9c63-fc80-4fe0-8ccb-a063a521d592",
                "title": "bar chart"
            },
            {
                "id": "f0015516-8c60-4d24-a67d-d6977a3fec5a",
                "title": "table"
            }
        ]
    },
    {
        "id": "bd20c8ec-6d25-4475-852b-0ab83fae49f9",
        "views": [
            {
                "id": "9de1c596-00b6-44d6-8ae6-58162d0296d6",
                "title": "bubble"
            },
            {
                "id": "0b69a73d-c50f-4f81-8368-3885ed733db4",
                "title": "tree map"
            },
            {
                "id": "7edca25f-d64d-405f-ae82-5ae9984086e7",
                "title": "bar chart"
            },
            {
                "id": "48b40f99-7953-4833-bf71-3efc43c72336",
                "title": "table"
            }
        ]
    },
    {
        "id": "3c33f034-6e25-468b-882d-0cb1605c61f9",
        "views": [
            {
                "id": "60457895-b338-4aa2-af6f-7d198d71ef86",
                "title": "bubble"
            },
            {
                "id": "392176e3-9427-4d6e-9b91-8de9a8a157c8",
                "title": "tree map"
            },
            {
                "id": "dc58485d-54cb-4aa9-b750-c007c332c2aa",
                "title": "bar chart"
            },
            {
                "id": "c7d4a892-0516-46e4-937f-f88b529b87c1",
                "title": "table"
            }
        ]
    },
    {
        "id": "b1a025e0-9e55-4c63-a4ea-ab577e7b8397",
        "views": [
            {
                "id": "d28c1886-dc57-46c3-bc28-51a36f80c0e0",
                "title": "bubble"
            },
            {
                "id": "ed7cf3a3-56c0-4880-b86d-a54348a8d3d6",
                "title": "tree map"
            },
            {
                "id": "55075f0d-04d2-4974-a426-462110b116ed",
                "title": "bar chart"
            },
            {
                "id": "fd3a8af9-1940-42fd-aeb2-dae65e238fce",
                "title": "table"
            }
        ]
    },
    {
        "id": "1c38a9b1-337a-4cfc-8ffb-36637455a072",
        "views": [
            {
                "id": "f5a7556b-66c9-4461-91a2-65c0f8f360fc",
                "title": "bubble"
            },
            {
                "id": "466f7f42-0bb5-403d-9bdd-64d5b27893d8",
                "title": "tree map"
            },
            {
                "id": "b40a7384-3b4c-4782-b240-7294714d6e52",
                "title": "bar chart"
            },
            {
                "id": "f9e3fc0a-ad10-45cb-b7d3-0a476ffc80cd",
                "title": "table"
            }
        ]
    }
];


export const sectionViewsMap = new Map(sectionViewIds.map(s => [s.id, s.views]));
